import type { TranslationKeys } from './es';

const it: TranslationKeys = {
  nav: { services: 'Servizi', about: 'Chi Siamo', blog: 'Blog', zones: 'Zone', contact: 'Contatti', login: 'Accedi', clientArea: 'Area Clienti', language: 'Lingua', home: 'Home', access: 'Accedi', search: 'Cerca su Punto Hispano', searchPlaceholder: 'Cosa cerchi? Es: assicurazioni, alloggio...', noResults: 'Nessun risultato per', tryOther: 'Prova altri termini', popularSearches: 'Ricerche popolari:', quickAccess: 'Accesso rapido:', freeConsultation: 'Consulenza Gratuita', allZones: 'Tutte le Zone', digitalBusiness: 'Impresa Digitale', aboutUs: 'Chi Siamo', closeMenu: 'Chiudi menu', openMenu: 'Apri menu' },
  hero: { title: 'Il tuo studio di gestione in Svizzera', subtitle: 'Gestione, consulenza legale, assicurazioni, lingue e soluzioni digitali per italiani in Svizzera.', cta: 'Consulenza Gratuita', ctaSecondary: 'Vedi Servizi', trustBadge: '+2.500 famiglie si fidano di noi', experience: '+12 anni di esperienza', act: 'ATTO I', actSubtitle: 'CHI SIAMO', titleLine1: 'GESTIONE E', titleLine2: 'CONSULENZA', titleLine3: 'IN SVIZZERA', cinematicSubtitle: 'Il tuo ponte verso il successo in Svizzera. Oltre 12 anni di assistenza agli italiani.', discoverServices: 'Scopri i Servizi', scheduleConsultation: 'Prenota Consulenza' },
  services: { title: 'I Nostri Servizi', subtitle: 'Tutto ciò di cui hai bisogno per vivere tranquillo in Svizzera', gestoria: { name: 'Gestione Amministrativa', description: 'Gestione completa: RAV, tasse, permessi, CV, traduzioni.', cta: 'Consulta Servizi' }, legal: { name: 'Consulenza Legale', description: 'Diritto degli stranieri, lavoro, famiglia, commerciale.', cta: 'Consulenza Legale' }, seguros: { name: 'Assicurazioni e Previdenza', description: 'Assicurazioni sanitarie, vita, casa, veicoli.', cta: 'Preventivo Gratuito' }, idiomas: { name: 'Corsi di Lingue', description: 'Tedesco e inglese. Livelli A1-C1.', cta: 'Vedi Corsi' }, digital: { name: 'Soluzioni Digitali', description: 'Web design, CRM, automazione con IA.', cta: 'Vedi Portfolio' }, relocation: { name: 'Pacchetto Relocation', description: 'Tutto per il tuo trasferimento in Svizzera.', cta: 'Pacchetto Completo' }, vehiculos: { name: 'Noleggio Veicoli', description: 'Noleggio auto e furgoni.', cta: 'Vedi Veicoli' }, viviendas: { name: 'Affitto Alloggi', description: 'Appartamenti e stanze.', cta: 'Vedi Alloggi' }, resultsTitle: 'RISULTATI CHE', resultsTitleAccent: 'TRASFORMANO', resultsSubtitle: 'Ogni servizio risolve un problema reale.', viewAll: 'Vedi tutti i servizi', explore: 'Esplora', gestoriaShort: 'Gestione', gestoriaDesc: 'Tasse, permessi e pratiche risolte senza stress.', gestoriaTags: 'Tasse • Permessi • RAV', legalShort: 'Consulenza Legale', legalDesc: 'Proteggi i tuoi diritti.', legalTags: 'Contratti • Eredità • Visti', idiomasShort: 'Lingue', idiomasDesc: 'Rompi la barriera linguistica.', idiomasTags: 'Tedesco • Inglese • Certificati', segurosShort: 'Assicurazioni', segurosDesc: 'Risparmia fino al 35% sui premi.', segurosTags: 'Salute • 3° Pilastro • Vita', vehiculosShort: 'Noleggio Auto', vehiculosDesc: 'Muoviti liberamente dal primo giorno.', vehiculosTags: 'Auto • Furgoni • SUV', viviendasShort: 'Affitto Alloggi', viviendasDesc: 'Trova la tua casa senza competere.', viviendasTags: 'Stanze • Appartamenti • WG', digitalShort: 'Soluzioni Digitali', digitalDesc: 'Moltiplica le tue vendite con sito, CRM e IA.', digitalTags: 'Web • CRM • IA', relocationShort: 'Pacchetto Relocation', relocationDesc: 'Arriva in Svizzera senza paura.', relocationTags: 'Tutto incluso', badgeBestSeller: 'Più venduto', badgeNew: 'Nuovo', badgeSave: 'Risparmia 25%', act: 'ATTO II', actSubtitle: 'SERVIZI' },
  process: { act: 'ATTO III', actSubtitle: 'PROCESSO', title: 'DAL TUO PROBLEMA ALLA', titleAccent: 'TUA SOLUZIONE', subtitle: 'Nessuna clausola nascosta. Così semplice.', step1Title: 'Ti Ascoltiamo', step1Desc: 'Raccontaci cosa ti preoccupa.', step1Duration: 'Gratuito', step2Title: 'Piano Senza Sorprese', step2Desc: 'Saprai esattamente cosa facciamo e quanto costa.', step2Duration: '24-48h', step3Title: 'Noi Eseguiamo', step3Desc: 'Tu continui la tua vita. Noi risolviamo per te.', step3Duration: 'Variabile', step4Title: 'Problema Risolto', step4Desc: 'Restiamo con te fino a che tutto è risolto al 100%.', step4Duration: 'Continuo' },
  about: { title: 'Chi Siamo', subtitle: 'Conosci il team di Punto Hispano', mission: 'La nostra missione è facilitare la vita in Svizzera.', heroTitle: 'Chi siamo?', heroSubtitle: 'Siamo il ponte tra la tua lingua e la burocrazia svizzera. Dal 2013.', stats: { families: 'Famiglie', procedures: 'Pratiche', companies: 'Aziende', years: 'Anni' }, timeline: { t2013: { title: 'Il Primo Passo', desc: 'Santiago arriva in Svizzera.' }, t2019: { title: 'Crescita Senza Confini', desc: 'Centinaia di clienti.' }, t2023: { title: 'La Nostra Casa a Zurigo', desc: 'Ufficio a Opfikon.' }, t2025: { title: 'Oltre 2.500 Famiglie', desc: 'Team multidisciplinare.' } }, valuesTitle: 'I Nostri Valori', values: { transparency: { title: 'Trasparenza Totale', desc: 'Nessuna clausola nascosta.' }, empathy: { title: 'Empatia Reale', desc: 'Siamo stati al tuo posto.' }, results: { title: 'Risultati, Non Parole', desc: 'Ci misuriamo dai problemi risolti.' } } },
  contact: { title: 'Contatti', subtitle: 'Hai domande? Siamo qui per aiutarti', name: 'Nome', email: 'Email', phone: 'Telefono', message: 'Messaggio', send: 'Invia Messaggio', whatsapp: 'Scrivici su WhatsApp', schedule: 'Prenota Consulenza', address: 'Thurgauerstrasse 117, 1° Piano, Ufficio 181, 8152 Opfikon, Zurigo', heroTitle: 'Come possiamo aiutarti?', heroSubtitle: 'Siamo a un messaggio di distanza. Prima consulenza gratuita.', officeTitle: 'Il Nostro Ufficio', hours: 'Orario: Lun-Ven 09:00-18:00', responseTime: 'Rispondiamo entro 2 ore', freeConsultation: 'Prima consulenza 100% gratuita' },
  zones: { title: 'Zone di Servizio', subtitle: 'Da Zurigo, per tutto il mondo', description: 'Gestione, consulenza legale, assicurazioni e altro.', headquarters: 'Sede Principale', cities: 'città', countriesTitle: 'Paesi con Maggiore Presenza', notFound: 'Non trovi la tua zona?', notFoundDesc: 'Possiamo aiutarti online.', servicesIn: 'Servizi a', heroTitle: 'Ovunque Tu Sia, Ti Aiutiamo', heroSubtitle: 'Servizi professionali da Zurigo per tutta Europa.', europeTitle: 'Europa', allCountries: 'Vedi tutti i paesi', remoteServices: 'Servizi 100% online disponibili' },
  blog: { title: 'Blog', subtitle: 'Consigli, guide e notizie per la comunità italiana in Svizzera', readMore: 'Leggi di più', readTime: 'min di lettura', categories: 'Categorie', search: 'Cerca articoli...' },
  footer: { description: 'Il tuo studio di gestione in Svizzera', rights: 'Tutti i diritti riservati', privacy: 'Privacy Policy', cookies: 'Cookie Policy', legal: 'Note Legali', gdpr: 'GDPR', brandDesc: 'Il tuo partner integrale in Svizzera.', newsletter: 'Newsletter', newsletterDesc: 'Ricevi novità, consigli e offerte esclusive', subscribe: 'Iscriviti', emailPlaceholder: 'nome@esempio.com', followUs: 'Seguici su', servicesTitle: 'Servizi', gestoriaTitle: 'Gestione', lifestyleTitle: 'Lifestyle', zonesTitle: 'Zone', companyTitle: 'Azienda', legalTitle: 'Legale', zonesLink: 'Zone di Servizio', madeWith: 'Sviluppato con ❤️ da', desempleo: 'Disoccupazione (RAV)', administracion: 'Amministrazione', cvDoc: 'CV e Documenti', acompanamientos: 'Accompagnamenti', traducciones: 'Traduzioni', paquetes: 'Pacchetti Speciali' },
  common: { learnMore: 'Scopri di più', viewAll: 'Vedi Tutti', back: 'Indietro', next: 'Avanti', previous: 'Precedente', close: 'Chiudi', loading: 'Caricamento...', error: 'Si è verificato un errore', retry: 'Riprova', search: 'Cerca', noResults: 'Nessun risultato', freeConsultation: 'Consulenza Gratuita', whatsapp: 'WhatsApp', schedule: 'Prenota Appuntamento', callUs: 'Chiamaci', from: 'Da', our: 'I nostri', all: 'Tutti' },
  audience: { trustLine: 'Oltre 12 anni di assistenza agli italiani in Svizzera', empathy: 'Ti suona familiare?', empathyItems: ['Non capisci le lettere ufficiali', 'Ti senti perso con la burocrazia', 'Hai bisogno di aiuto con le tasse', 'Cerchi qualcuno che parli la tua lingua'], processTitle: 'Così Facile', processSteps: [{ title: 'Raccontaci il tuo caso', description: 'WhatsApp o appuntamento' }, { title: 'Ti consigliamo', description: 'Analizziamo e diamo opzioni' }, { title: 'Risolviamo', description: 'Gestiamo tutto per te' }] },
  navStructure: { traditional: 'Tradizionali', lifestyle: 'Lifestyle', digital: 'Digitali', europe: 'Europa', america: 'America', other: 'Altri', viewAllZones: 'Vedi tutte le zone', desempleo: 'Disoccupazione e RAV', administracion: 'Amministrazione', cvDoc: 'CV e Documenti', traducciones: 'Traduzioni', paquetes: 'Pacchetti Speciali', extranjeria: 'Diritto Stranieri', laboral: 'Diritto del Lavoro', familia: 'Diritto di Famiglia', mercantil: 'Diritto Commerciale', inmobiliario: 'Immobiliare e Fiscale', aleman: 'Tedesco', ingles: 'Inglese', seguroSalud: 'Assicurazione Sanitaria', vidaPension: 'Vita e Previdenza', hogarVehiculos: 'Casa e Veicoli', siniestros: 'Sinistri', comparador: 'Comparatore', packBasico: 'Pacchetto Base', packCompleto: 'Pacchetto Completo', paraEmpresas: 'Per Aziende', packRetorno: 'Pacchetto Rientro', formacionIdiomas: 'Corsi di Lingue', segurosYPensiones: 'Assicurazioni e Previdenza', alquilerVehiculos: 'Noleggio Veicoli', alquilerViviendas: 'Affitto Alloggi', solucionesDigitales: 'Soluzioni Digitali' },
  testimonials: { act: 'ATTO IV', actSubtitle: 'TESTIMONIANZE', title: 'LORO GIÀ VIVONO', titleAccent: 'SENZA PREOCCUPAZIONI', subtitle: 'Storie vere di persone come te', reviews: 'recensioni', viewReal: 'Vedi le recensioni reali su Google Maps', disclaimer: 'Le recensioni mostrate di seguito sono rappresentative dell\'esperienza dei nostri clienti. Per vedere le nostre recensioni autentiche e verificate, visita il nostro profilo su Google Maps.' },
  faq: { act: 'ATTO V', actSubtitle: 'FAQ', title: 'DOMANDE', titleAccent: 'FREQUENTI', subtitle: 'Tutto quello che devi sapere.', ctaText: 'Hai un\'altra domanda?', ctaLink: 'Contattaci direttamente', showMore: 'Mostra altre domande', showLess: 'Mostra meno' },
  cta: { act: 'ATTO VI', actSubtitle: 'CONTATTI', urgencyBadge: 'Posti limitati — Solo 5 consulenze gratuite questa settimana', title: 'NON ASPETTARE CHE', titleAccent: 'SIA TROPPO TARDI', subtitle: 'Ogni giorno senza risolvere è stress inutile. Fai il primo passo — è gratuito.', step1Label: 'Seleziona servizio', step2Label: 'Dati', step3Label: 'Conferma', stepTitle: 'Quale servizio ti interessa?', continueBtn: 'Continua al passo 2', trustResponse: 'Rispondiamo entro 24h', trustFamilies: '+2500 famiglie lo hanno risolto', trustLanguage: '100% nella tua lingua', serviceOther: 'Altro / Non sono sicuro' },
  trust: { headline: '+2.500 persone si sono liberate della burocrazia svizzera', verifiedLabel: 'Aziende verificate:', dataProtected: 'Dati 100% protetti', dataProtectedSub: 'Le tue informazioni sono sacre', registered: 'Azienda registrata in Svizzera', registeredSub: 'Verificabile su Moneyhouse', realOffice: 'Ufficio reale a Zurigo', realOfficeSub: 'Non siamo una casella postale', experience: '12+ anni, 2500+ famiglie', experienceSub: 'Risultati dimostrabili' },
  homeFaq: { questions: [{ question: 'Sono appena arrivato in Svizzera e non so da dove iniziare. Potete aiutarmi?', answer: 'Assolutamente. Sappiamo quanto sia travolgente arrivare in un nuovo paese. Il nostro Pacchetto Relocation copre tutto: permessi, assicurazioni, banca, alloggio e altro. Un coordinatore personale ti guida passo dopo passo.' }, { question: 'Quanto costa la prima consulenza? C\'è un impegno?', answer: 'La prima consulenza è 100% gratuita e senza impegno. In 10 minuti ascoltiamo il tuo caso, capiamo di cosa hai bisogno e ti spieghiamo come possiamo aiutarti.' }, { question: 'Sto pagando troppe tasse. Potete ottimizzare la mia dichiarazione?', answer: 'È quello che facciamo meglio. In oltre 12 anni abbiamo recuperato migliaia di franchi per i nostri clienti con detrazioni che non conoscevano.' }, { question: 'Ho un problema legale e non capisco le leggi svizzere. Cosa faccio?', answer: 'Non sei solo. I nostri consulenti legali parlano la tua lingua e conoscono il diritto svizzero nei dettagli. Contratti di lavoro, ricongiungimento familiare, eredità, permessi — proteggiamo i tuoi diritti.' }, { question: 'Devo imparare il tedesco ma i corsi convenzionali non funzionano per me.', answer: 'Perché non sono progettati per gli ispanofoni. La nostra metodologia parte dalle difficoltà specifiche. Corsi da A1 a C1, in presenza a Zurigo o online.' }, { question: 'Come faccio a sapere se sto pagando troppo per la mia assicurazione sanitaria?', answer: 'Probabilmente sì — il 70% dei nostri clienti risparmia in media il 35% dopo il nostro confronto gratuito.' }, { question: 'Servite solo a Zurigo o anche a distanza?', answer: 'Il nostro ufficio è a Opfikon (Zurigo), ma serviamo clienti da tutta la Svizzera e dall\'estero. L\'80% dei nostri servizi è 100% online.' }, { question: 'Perché dovrei fidarmi di Punto Hispano e non di un altro?', answer: 'Perché siamo un\'azienda registrata e verificabile su Moneyhouse. Più di 2.500 famiglie ci hanno scelto. 4,9 stelle su Google.' }], additionalQuestions: [{ question: 'Dove siete esattamente? Posso venire in ufficio?', answer: 'Sì, siamo in Thurgauerstrasse 117, 8152 Opfikon, Zurigo (1° Piano, Ufficio 181). Lunedì a venerdì 9:00-18:00, sabato su appuntamento.' }, { question: 'Voglio assicurare la mia pensione. Quali opzioni ho con il 3° Pilastro?', answer: 'Il 3° Pilastro è il miglior strumento per assicurare il tuo futuro E risparmiare sulle tasse oggi. Confrontiamo tutte le opzioni di mercato.' }, { question: 'La mia azienda ha bisogno di una presenza digitale. Potete aiutare?', answer: 'Progettiamo siti che vendono. CRM personalizzato, automazione IA, marketing digitale e SEO.' }, { question: 'Ho bisogno di un\'auto senza complicazioni di contratti lunghi.', answer: 'Noleggio flessibile: da giorni a mesi. Utilitarie, SUV e furgoni. Assicurazione completa inclusa.' }, { question: 'Trovare un appartamento in Svizzera è impossibile. Potete davvero aiutarmi?', answer: 'Abbiamo accesso a una rete esclusiva di proprietari, gestiamo le visite e ti accompagniamo alla firma.' }, { question: 'Cosa include esattamente il Pacchetto Relocation?', answer: 'TUTTO: ricerca alloggio, apertura conto bancario, registrazione comunale, assicurazioni obbligatorie, CV adattato, corsi di tedesco e un coordinatore personale. Risparmi il 25%.' }, { question: 'Come pago? Accettate pagamenti rateali?', answer: 'Bonifico, carta, TWINT o PayPal. Sì, offriamo rateizzazione per servizi di importo maggiore.' }, { question: 'Non ho ancora il permesso di soggiorno. Potete aiutarmi comunque?', answer: 'Sì. Aiutiamo a regolarizzare situazioni migratorie e consigliamo sulle migliori vie per ottenere il permesso.' }] },
  seo: { homeTitle: 'Punto Hispano | Gestione Amministrativa in Svizzera', homeDescription: 'Il miglior studio di gestione a Zurigo per italiani in Svizzera.' },
  servicesIndex: { heroTitle: 'Tutti i Nostri Servizi', heroSubtitle: 'La tua soluzione completa in Svizzera.', heroCta: 'Consulenza Gratuita su WhatsApp', categories: { gestoria: { title: 'Gestione Amministrativa', description: 'Tasse, RAV, permessi — ci occupiamo di tutto noi.', cta: 'Voglio vivere tranquillo', features: ['Dichiarazione senza errori', 'Permessi aggiornati', 'Niente stress', 'Risparmio fiscale reale'] }, legal: { title: 'Consulenza Legale', description: 'Un contratto che non capisci può costarti migliaia di franchi.', cta: 'Proteggere i miei diritti', features: ['Contratti verificati', 'Permessi risolti', 'Ricongiungimento familiare', 'Tranquillità legale'] }, idiomas: { title: 'Corsi di Lingue', description: 'Senza lingua, niente lavoro. I nostri corsi sono per parlare.', cta: 'Iniziare a parlare', features: ['Insegnanti madrelingua', 'Livelli A1-C1', 'Gruppi ridotti', 'Certificati ufficiali'] }, seguros: { title: 'Assicurazioni e Previdenza', description: 'Ogni anno perdi centinaia di franchi. Troviamo la migliore.', cta: 'Confrontare e risparmiare', features: ['Risparmio fino al 35%', 'Consulente personale', 'Tutte le compagnie', 'Senza impegno'] }, digital: { title: 'Soluzioni Digitali', description: 'La tua concorrenza ha già sito web e CRM. E tu?', cta: 'Vedere cosa possiamo fare', features: ['Sito professionale', 'CRM personalizzato', 'IA e automazione', 'Marketing digitale'] }, vehiculos: { title: 'Noleggio Veicoli', description: 'Muoviti liberamente. Auto, furgoni e SUV.', cta: 'Vedi veicoli', features: ['Nessun deposito eccessivo', 'Assicurazione inclusa', 'Ritiro flessibile', 'Prezzi competitivi'] }, viviendas: { title: 'Affitto Alloggi', description: 'Trova la tua casa senza competere con 200 candidati.', cta: 'Cercare alloggio', features: ['Verificati', 'Nessuna commissione nascosta', 'Breve e lungo periodo', 'Zone centrali'] }, relocation: { title: 'Pacchetto Relocation', description: 'Arriva in Svizzera con tutto risolto.', cta: 'Voglio arrivare tranquillo', features: ['Tutto incluso', 'Consulente personale', 'Prima di arrivare', 'Garanzia di risultato'] } } },
  aboutPage: { seoTitle: 'Chi Siamo — Punto Hispano, Gestione Amministrativa in Svizzera', seoDesc: 'Scopri Punto Hispano: 12+ anni di assistenza in Svizzera.', heroSub: 'Chi Siamo — Punto Hispano, Gestione Amministrativa in Svizzera', heroTitle1: 'Lo Studio di Fiducia', heroTitle2: 'per gli ', heroTitle3: 'Italiani', heroTitle4: 'in Svizzera', heroDesc: 'Siamo arrivati in Svizzera come te. Sappiamo cosa si prova a non capire una lettera delle tasse. Per questo abbiamo creato Punto Hispano.', knowServices: 'Scopri i Nostri Servizi →', talkToUs: 'Parlaci', originTitle: 'Non Abbiamo Creato un\'Azienda. Abbiamo Risolto un Problema Che Abbiamo Vissuto.', originP1: 'Nel 2013, Santiago Castillo ha affrontato la stessa cosa: un paese nuovo, una lingua che non dominava. Ha cercato aiuto in spagnolo e non l\'ha trovato. Così l\'ha creato.', originP2: 'Oggi, Punto Hispano è il luogo dove più di 2.500 famiglie hanno trovato qualcuno che parla la loro lingua e difende i loro diritti.', originP3: 'Non siamo un\'azienda che vende servizi. Siamo persone che hanno risolto lo stesso problema.', originBadge: '🇨🇭 Da Zurigo, per tutta la comunità in Svizzera', timelineTitle: '12 Anni di Crescita con Te', founderTag: 'Fondatore', founderName: 'Santiago Castillo', founderQuote: '"Sono arrivato in Svizzera con una valigia e zero contatti. Nessuno mi ha spiegato le tasse, le assicurazioni o i permessi. L\'aiuto in spagnolo non esisteva. Così l\'ho creato io."', founderDesc: 'Oggi, dopo più di 12 anni, Punto Hispano è il riferimento della comunità.', founderExp: 'Oltre 12 anni di esperienza', teamTitle: 'Un Team Completo al Tuo Servizio', teamSubtitle: 'Tutto sotto un unico tetto.', teamStats: [{ number: '8+', text: 'Professionisti', sub: 'Gestori, avvocati, consulenti assicurativi, insegnanti di lingue' }, { number: '100%', text: 'Team che parla la tua lingua', sub: 'Ci capiamo senza traduttori.' }, { number: '5+', text: 'Aree di specializzazione', sub: 'Gestione, legale, assicurazioni, lingue, digitale' }], missionTitle: 'La Nostra Missione', missionWhat: 'Cosa Facciamo Ogni Giorno', missionWhatDesc: 'Risolvere i problemi reali. Niente servizi generici: ascoltiamo, capiamo e risolviamo professionalmente.', missionWhere: 'Dove Stiamo Andando', missionWhereDesc: 'Che nessuno si senta solo di fronte a un problema. Vogliamo essere la tua prima chiamata.', allServices: 'Tutto Ciò Che Punto Hispano Può Fare per Te', allServicesSub: 'Più di 20 soluzioni specifiche.', commitmentsTitle: 'Tre Impegni Che Manteniamo Sempre', commitments: [{ title: 'Risposta in Meno di 2 Ore', desc: 'In orario lavorativo, rispondiamo entro 2 ore.', proof: 'Impegno verificabile' }, { title: 'Prima Consulenza Gratuita', desc: 'Ascoltiamo e diamo una diagnosi chiara. Senza impegno.', proof: '100% gratuita' }, { title: '4.9★ su Google', desc: 'Più di 2.500 famiglie ci hanno scelto e ci raccomandano.', proof: 'Valutazioni reali' }], joinTitle: 'Vuoi Far Parte del Team?', joinDesc: 'Cerchiamo professionisti appassionati.', joinCta: '✉️ Inviaci il tuo CV →', finalTitle: 'Hai un Problema in Svizzera? Raccontacelo.', finalDesc: 'Non devi risolvere tutto da solo/a. Fai il primo passo.', finalCta: 'Prenota Consulenza Gratuita →', finalServices: 'Vedi Tutti i Servizi →' },
  zonesPage: { seoTitle: 'Zone di Servizio | Punto Hispano - Da Zurigo per Tutto il Mondo', seoDesc: 'Gestione amministrativa, consulenza legale, assicurazioni e altro.', heroTitle: 'Serviamo la Tua Zona', heroSubtitle: 'Da Zurigo, per tutto il mondo. Gestione, consulenza legale, assicurazioni e altro.', hq: 'Sede Principale', switzerland: 'Svizzera', switzerlandDesc: 'Con il nostro ufficio a Opfikon (Zurigo), serviamo tutta la comunità in Svizzera.', countriesTitle: 'Paesi con Maggiore Presenza', countriesSubtitle: 'Trova i nostri servizi in Svizzera, Spagna, Italia e America Latina.', cities: 'città', notFoundTitle: 'Non trovi la tua zona?', notFoundDesc: 'Ovunque tu sia, possiamo aiutarti online.', whatsappCta: 'Contattare via WhatsApp', scheduleCta: 'Prenota Consulenza' },
  blogPage: { seoTitle: 'Blog Punto Hispano | Guide per la Vita in Svizzera', seoDesc: 'Guide su tasse, permessi, assicurazioni e vita in Svizzera.', heroTitle: 'Blog di Punto Hispano — ', heroTitleAccent: 'Guide e Consigli per la Vita in Svizzera', heroDesc: 'Tutto quello che devi sapere per vivere, lavorare e prosperare in Svizzera.', all: 'Tutti', readArticle: 'Leggi articolo', readTime: 'min di lettura', noArticles: 'Nessun articolo disponibile in questa categoria.', newsletterTitle: '📬 Ricevi i Nostri Articoli via Email', newsletterDesc: 'Un email a settimana. Niente spam, solo contenuti utili.', emailPlaceholder: 'La tua email...', subscribe: 'Iscriviti', noSpam: '🔒 Senza spam. Cancellabile in qualsiasi momento.' },
  blogPost: { home: 'Home', blog: 'Blog', author: 'Team Punto Hispano', minRead: 'min di lettura', needHelpMobileTitle: 'Hai bisogno di aiuto?', needHelpMobileDesc: 'Prima consulenza gratuita. Il nostro team può occuparsene per te.', scheduleConsult: 'Prenota Consulenza →', endCtaTitle: 'Vuoi che ce ne occupiamo noi?', endCtaDesc: 'Non devi farlo da solo/a. Prenota la tua consulenza gratuita e ti spiegheremo esattamente come possiamo aiutarti.', endCtaButton: 'Prenota Consulenza Gratuita →', endCtaResponse: '⏰ Risposta in meno di 2 ore in orario lavorativo', keepReading: 'Continua a leggere', backToBlog: 'Torna al Blog', sidebarHelpTitle: 'Hai bisogno di aiuto?', sidebarHelpDesc: 'Prima consulenza gratuita. Il nostro team può occuparsene per te.', relatedArticles: 'Articoli correlati', mobileStickyCta: 'Consulenza gratuita' },
  zonesDetail: {
    seoTitleCountry: 'Servizi in {country} | Punto Hispano - Assistenza da Zurigo',
    seoDescCountry: 'Gestione, consulenza legale, assicurazioni e lingue in {country}. Assistenza in presenza e online da Opfikon, Zurigo.',
    seoTitleCity: 'Servizi a {city}, {country} | Punto Hispano',
    seoDescCity: 'Gestione, consulenza legale, assicurazioni e altro a {city}. Assistenza in presenza e online da Opfikon, Zurigo.',
    citiesIn: 'Città in {country}',
    findYourCity: 'Trova la tua città e scopri tutti i servizi disponibili.',
    cities: 'città',
    featured: '★ In evidenza',
    noZones: 'Nessuna zona disponibile in questo paese al momento.',
    contactAnyway: 'Contattaci comunque',
    dontSeeCity: 'Non vedi la tua città?',
    dontSeeCityDesc: 'Non importa dove sei in {country}, ti assistiamo online da Zurigo.',
    contactWhatsApp: 'Contatta via WhatsApp',
    allZones: 'Tutte le zone',
    servicesForIn: 'Servizi per Italiani a {city}',
    servicesFullDesc: 'A Punto Hispano offriamo una gamma completa di servizi a {city}. Dalla gestione amministrativa alla consulenza legale, assicurazioni, corsi di lingue e soluzioni digitali. Il nostro ufficio principale è a Opfikon (Zurigo), ma ti assistiamo online ovunque tu sia.',
    needHelpIn: 'Hai bisogno di aiuto a {city}?',
    remoteAttention: 'Anche se sei a {city}, ti assistiamo come se fossi nel nostro ufficio di Zurigo. Contattaci oggi.',
    officeOpfikon: 'Ufficio a Opfikon, Svizzera',
    inPersonAndOnline: 'Assistenza in presenza e online',
    scheduleConsultation: 'Prenota Consulenza',
    otherCitiesIn: 'Altre città in {country}',
    exploreMore: 'Esplora altre zone dove offriamo i nostri servizi.',
    viewAllCitiesIn: 'Vedi tutte le città in {country}',
    backTo: 'Torna a {country}',
    allServices: 'Tutti i Nostri Servizi',
    servicesIn: 'Servizi a {zone}',
    availableFromOffice: 'Disponibili in presenza e online dal nostro ufficio a Opfikon, Zurigo.',
    viewMore: 'Scopri di più',
    mainOffice: 'Ufficio Principale',
    onlineConsultation: 'Consulenza Online',
    serviceGestoria: 'Gestione',
    serviceGestoriaDesc: 'Tasse, permessi, RAV',
    serviceLegal: 'Consulenza Legale',
    serviceLegalDesc: 'Contratti, visti, eredità',
    serviceLanguages: 'Lingue',
    serviceLanguagesDesc: 'Tedesco, inglese, certificati',
    serviceInsurance: 'Assicurazioni',
    serviceInsuranceDesc: 'Salute, vita, 3° pilastro',
    serviceCarRental: 'Noleggio Auto',
    serviceCarRentalDesc: 'Auto, furgoni',
    serviceHousing: 'Alloggi',
    serviceHousingDesc: 'Stanze, appartamenti, WG',
    serviceDigital: 'Digitale',
    serviceDigitalDesc: 'Web, CRM, IA, automazione',
    serviceRelocation: 'Pacchetto Relocation',
    serviceRelocationDesc: 'Tutto incluso per iniziare',
    howWeHelp: 'Come Ti Aiutiamo',
    remotely: 'a Distanza',
    remoteDesc: 'Anche se sei a {city}, ti assistiamo come nel nostro ufficio di Zurigo.',
    remoteDescGeneral: 'Da Zurigo, per tutto il mondo. Assistenza professionale indipendentemente dalla tua posizione.',
    step1Title: 'Contattaci',
    step1Desc: 'Scrivici su WhatsApp, email o chiamaci. Risposta entro 24h.',
    step2Title: 'Consulenza Online',
    step2Desc: 'Fissiamo una videochiamata per capire la tua situazione e le tue esigenze.',
    step3Title: 'Risoluzione',
    step3Desc: 'Gestiamo tutto da remoto. Tu firmi solo i documenti necessari.',
    benefit1: 'Risposta in 24h',
    benefit2: '+12 anni di esperienza',
    benefit3: 'Assistenza multilingue',
    home: 'Home',
    zones: 'Zone',
    gestoriaAndAdvice: 'Gestione e Consulenza a {city}',
    professionalServices: 'Servizi professionali a {city}',
    servicesDescription: 'Gestione, consulenza legale, assicurazioni e altro in {country}. Assistenza dal nostro ufficio di Zurigo.',
  },
  gestoriaPage: {
    seoTitle: 'Gestione Amministrativa in Svizzera | Tasse, Permessi, URC | Punto Hispano',
    seoDesc: 'Gestione amministrativa in spagnolo in Svizzera. Iscrizione URC, dichiarazione delle tasse, traduzioni ufficiali, creazione di imprese. Oltre 12 anni di esperienza.',
    heroTitle: 'Gestione Amministrativa in Svizzera',
    heroAccent: '— Tasse, Permessi e URC in Spagnolo',
    heroDesc: 'Un altro anno senza capire la tua dichiarazione dei redditi? Lettere dall\'URC a cui non sai rispondere? Ci occupiamo noi di tutto. Tu ricevi solo il risultato.',
    heroCta: 'Vedi tutti i servizi ↓',
    heroWhatsapp: 'Consulenza gratuita via WhatsApp',
    badge1: '+2.500 famiglie',
    badge2: 'Risposta < 2h',
    badge3: '12+ anni',
    empathyTitle: 'Ti suona familiare?',
    empathy1: 'La scadenza della dichiarazione si avvicina e non capisci nemmeno la prima riga',
    empathy2: 'Ricevi lettere dall\'URC in tedesco e non sai cosa ti stanno chiedendo',
    empathy3: 'Devi rinnovare il permesso e hai paura che te lo rifiutino',
    empathy4: 'Vuoi aprire un\'azienda ma la burocrazia svizzera ti paralizza',
    empathyBottom: 'Se ti riconosci, sei nel posto giusto.',
    categoriesTitle: 'Cosa devi risolvere?',
    categoriesDesc: 'Scegli la tua situazione e ti mostriamo esattamente come possiamo aiutarti.',
    packagesTitle: 'Pacchetti tutto incluso',
    packagesDesc: 'Soluzioni complete per situazioni concrete.',
    requestPack: 'Richiedi pacchetto',
    processTitle: 'Così semplice',
    step1Title: 'Raccontaci il tuo caso',
    step1Desc: 'Scrivici su WhatsApp o compila il modulo',
    step2Title: 'Ricevi il tuo piano',
    step2Desc: 'Ti diciamo cosa ti serve e quanto costa',
    step3Title: 'Ci occupiamo noi',
    step3Desc: 'Tu ci dai i documenti, noi facciamo il resto',
    ctaTitle: 'Non sai quale servizio ti serve?',
    ctaDesc: 'Raccontaci la tua situazione e ti diremo esattamente di cosa hai bisogno. Gratis e senza impegno.',
    ctaWhatsapp: 'Consulenza gratuita via WhatsApp',
    ctaSchedule: 'Prenotare una chiamata',
    faqTitle: 'Domande frequenti',
    faq1Q: 'Quanto costa l\'iscrizione all\'URC?',
    faq1A: 'Scrivici su WhatsApp o compila il nostro modulo di contatto e ti invieremo un preventivo personalizzato in meno di 2 ore. Il Pack Iscrizione URC include tutta la documentazione, CV formato svizzero, lettera di presentazione, registrazione JOB-room e accompagnamento al primo appuntamento.\n\n⚠️ Ricorda: devi iscriverti PRIMA del tuo primo giorno senza lavoro.',
    faq2Q: 'Come posso fare la mia dichiarazione dei redditi?',
    faq2A: 'Puoi farla da solo o usare il nostro servizio di dichiarazione dei redditi. Esaminiamo la tua situazione completa, applichiamo TUTTE le deduzioni possibili e la presentiamo nei tempi previsti.\n\n⚠️ Scadenza: nella maggior parte dei cantoni, la data limite è il 31 marzo.',
    faq3Q: 'La prima consulenza è gratuita?',
    faq3A: 'Sì. Offriamo una prima consulenza gratuita di 10 minuti in cui ascoltiamo il tuo caso e identifichiamo di cosa hai bisogno. Puoi venire nel nostro ufficio a Opfikon, chiamarci o scriverci su WhatsApp. Senza impegno.',
    faqMore: 'Altre domande? Contattaci →',
    reviewsTitle: 'Cosa dicono i nostri clienti',
    reviewsDesc: 'Esperienze reali di famiglie ispanofone',
    reviewsMore: 'Vedi tutte le recensioni su Google →',
    crossSellTitle: 'Scopri i nostri altri servizi',
    crossSellDesc: 'Tutto ciò di cui un ispanofono ha bisogno in Svizzera, sotto lo stesso tetto.',
    finalTitle: 'Smetti di preoccuparti. Inizia oggi.',
    finalDesc: 'Ogni giorno senza risolvere le tue pratiche è un giorno di stress in più.',
    finalCta: 'Consulenza gratuita via WhatsApp',
    finalBack: 'Vedi servizi ↑',
  },
  homeSeo: {
    title: 'Punto Hispano | Gestione, Legale e Relocation in Svizzera',
    description: 'Perso con le pratiche in Svizzera? +2500 ispanofoni hanno ritrovato la tranquillità. Tasse, permessi, assicurazioni, alloggio e altro.',
    skipButton: 'Vedi sito completo',
  },

  legalPage: {
    seoTitle: 'Consulenza Legale per Ispanofoni in Svizzera | Punto Hispano',
    seoDesc: 'Consulenza legale in spagnolo in Svizzera. Immigrazione, lavoro, famiglia, commerciale, immobiliare. Prima consulenza gratuita.',
    heroTitle: 'Consulenza Legale per Ispanofoni in Svizzera',
    heroAccent: '— Permessi, Lavoro, Famiglia e Imprese in Spagnolo',
    heroDesc: 'Problemi con il permesso, licenziamento ingiusto, divorzio, debiti... Non devi risolvere tutto da solo/a. Ti consigliamo in spagnolo con specialisti del diritto svizzero.',
    heroCta: 'Vedi Aree di Pratica ↓',
    heroWhatsapp: 'Consulenza Gratuita via WhatsApp',
    badge1: '+2.500 famiglie',
    badge2: 'Risposta < 2h',
    badge3: '12+ anni',
    empathyTitle: 'Ti suona familiare qualcuna di queste situazioni?',
    empathy1: 'Sei stato licenziato e pensi sia ingiusto ma non sai cosa fare',
    empathy2: 'Sei in procedura di divorzio e non capisci la legge svizzera',
    empathy3: 'Ti hanno negato il permesso e non sai come fare ricorso',
    empathy4: 'Il proprietario ti ha aumentato l\'affitto e non sai se è legale',
    empathyBottom: 'Se ti identifichi con qualcuna, sei nel posto giusto.',
    categoriesTitle: 'Le Nostre Aree di Pratica Legale',
    categoriesDesc: 'Scegli la tua situazione e ti mostriamo come possiamo aiutarti.',
    cat1Name: 'Immigrazione e Permessi',
    cat1Desc: 'Permessi B, C, G, rinnovi, ricongiungimento familiare, ricorso per diniego, cittadinanza svizzera.',
    cat1Badge: '7 servizi disponibili',
    cat2Name: 'Diritto del Lavoro',
    cat2Desc: 'Licenziamenti, contratti, reclami, mobbing, certificati di lavoro, straordinari, fallimento datore.',
    cat2Badge: '8 servizi disponibili',
    cat3Name: 'Diritto di Famiglia',
    cat3Desc: 'Divorzi, affidamento, alimenti, separazione dei beni, mediazione, ricongiungimento figli.',
    cat3Badge: '7 servizi disponibili',
    cat4Name: 'Diritto Commerciale e Societario',
    cat4Desc: 'Costituzione imprese, contratti, controversie tra soci, recupero crediti, reclami assicurativi.',
    cat4Badge: '6 servizi disponibili',
    cat5Name: 'Immobiliare e Fiscale',
    cat5Desc: 'Compravendita, affitti, controversie con proprietari, ottimizzazione fiscale, ricorsi tributari.',
    cat5Badge: '6 servizi disponibili',
    viewServices: 'Vedi servizi →',
    ctaTitle: 'Non sai quale area legale ti serve?',
    ctaDesc: 'Raccontaci la tua situazione e ti orientiamo gratis. Senza impegno.',
    ctaWhatsapp: 'Consulenza Gratuita via WhatsApp',
    ctaSchedule: 'Pianifica una Chiamata',
    processTitle: 'Così semplice',
    step1: 'Raccontaci il tuo caso',
    step2: 'Ricevi il tuo piano legale',
    step3: 'Ci occupiamo noi',
    faqTitle: 'Domande Frequenti',
    faqMore: 'Vedi altre domande →',
    reviewsTitle: 'Cosa dicono i nostri clienti',
    crossSellTitle: 'Scopri i nostri altri servizi',
    crossSellDesc: 'Tutto ciò di cui un ispanofono ha bisogno in Svizzera, sotto un unico tetto.',
    finalTitle: 'Hai bisogno di consulenza legale?',
    finalDesc: 'Prima consulenza gratuita con i nostri specialisti in diritto svizzero.',
    finalCta: 'Richiedi Consulenza Gratuita',
  },

  idiomasPage: {
    seoTitle: 'Formazione Linguistica per Ispanofoni in Svizzera | Punto Hispano',
    seoDesc: 'Corsi di tedesco e inglese progettati per ispanofoni. Lezioni in presenza e online a Zurigo.',
    heroTitle: 'Formazione Linguistica per Ispanofoni in Svizzera',
    heroAccent: '— Tedesco, Inglese e Certificazioni Ufficiali',
    heroDesc: 'Dalle migliori scuole di Zurigo con metodologia progettata per ispanofoni. Impara più velocemente, con meno frustrazione, e certificati con garanzia.',
    heroCta: 'Vedi Corsi ↓',
    badge1: '+450 studenti',
    empathyTitle: 'Ti suona familiare qualcuna di queste situazioni?',
    empathy1: 'Non capisci nulla in ufficio e tutto è in tedesco',
    empathy2: 'Hai bisogno del B1 per il permesso C e non sai da dove iniziare',
    empathy3: 'Il tuo capo richiede inglese professionale e ti blocchi nelle riunioni',
    empathy4: 'Vuoi certificarti ma gli esami ufficiali ti spaventano',
    empathyBottom: 'Se ti identifichi con qualcuna, sei nel posto giusto.',
    coursesTitle: 'Cosa vuoi imparare?',
    coursesDesc: 'Scegli il tuo obiettivo e ti mostriamo il percorso più veloce.',
    germanTitle: 'Corsi di Tedesco',
    germanDesc: 'In presenza e online. Lezioni di gruppo e private. Da A1 a C1, con metodologia adattata per ispanofoni.',
    germanBadge: 'In presenza · Online · Privato',
    germanCta: 'Vedi corsi di tedesco →',
    englishTitle: 'Corsi di Inglese',
    englishDesc: 'In presenza e online. Lezioni di gruppo e private. Business English, conversazione e preparazione certificazioni.',
    englishBadge: 'In presenza · Online · Privato',
    englishCta: 'Vedi corsi di inglese →',
    processTitle: 'Così semplice',
    step1Title: 'Fai il tuo test di livello',
    step1Desc: 'Valutiamo il tuo livello attuale in una chiamata o con il nostro modulo',
    step2Title: 'Scegli il tuo corso',
    step2Desc: 'Ti raccomandiamo il programma ideale per i tuoi obiettivi',
    step3Title: 'Inizia a parlare',
    step3Desc: 'Dalla prima lezione pratichi conversazione reale',
    ctaTitle: 'Non sai quale corso ti serve?',
    ctaDesc: 'Fai il test di livello gratuito e ti raccomandiamo il programma perfetto.',
    ctaWhatsapp: 'Contattaci via WhatsApp',
    faqTitle: 'Domande Frequenti',
    faqMore: 'Altre domande? Scrivici →',
    reviewsTitle: 'Cosa dicono i nostri studenti',
    reviewsDesc: 'Esperienze reali di ispanofoni che hanno imparato con noi',
    reviewsMore: 'Vedi tutte le recensioni su Google →',
    crossSellTitle: 'Scopri i nostri altri servizi',
    crossSellDesc: 'Tutto ciò di cui un ispanofono ha bisogno in Svizzera, sotto un unico tetto.',
    finalTitle: 'Pronto/a a padroneggiare la lingua?',
    finalDesc: 'Ogni settimana senza imparare è un\'opportunità persa.',
    finalCta: 'Lezione di prova gratuita',
  },

  segurosPage: {
    seoTitle: 'Assicurazione Sanitaria in Spagnolo in Svizzera | LAMal | Terzo Pilastro | Punto Hispano',
    seoDesc: 'Consulenza assicurativa in spagnolo in Svizzera. Assicurazione sanitaria obbligatoria LAMal, terzo pilastro, pensioni. Consulenza gratuita. Risparmia fino al 30%.',
    heroTitle: 'Assicurazioni e Pensioni per Ispanofoni in Svizzera',
    heroAccent: '— LAMal, Terzo Pilastro e Risparmio in Spagnolo',
    heroDesc: 'Il 70% degli ispanofoni in Svizzera paga più del necessario per l\'assicurazione sanitaria. Analizziamo la tua polizza, troviamo il risparmio e gestiamo il cambio completo.',
    heroCta: 'Vedi tutti i servizi ↓',
    heroWhatsapp: 'Consulenza gratuita via WhatsApp',
    breadServices: 'Servizi',
    breadSeguros: 'Assicurazioni e Pensioni',
    badge1: 'CICERO N. 31700',
    badge2: 'FINMA N. F014686595',
    badge3: '+20.000 persone assicurate in 5 anni',
    empathyTitle: 'Ti suona familiare qualcuna di queste situazioni?',
    empathy1: 'Non rivedi il terzo pilastro da anni e non sai se stai perdendo soldi',
    empathy2: 'La tua famiglia è cresciuta ma la tua assicurazione è rimasta uguale',
    empathy3: 'Ricevi lettere dall\'assicuratore in tedesco e non capisci cosa chiedono',
    empathy4: 'Paghi oltre 400 CHF/mese di assicurazione sanitaria e non sai se è necessario',
    empathyBottom: 'Se ti identifichi con qualcuna, sei nel posto giusto.',
    servicesTitle: 'Cosa devi proteggere?',
    servicesDesc: 'Scegli la tua situazione e ti mostriamo come risparmiare senza perdere copertura.',
    processTitle: 'Così semplice',
    step1Title: 'Raccontaci la tua situazione',
    step1Desc: 'Dicci quali assicurazioni hai e quanto paghi',
    step2Title: 'Confrontiamo per te',
    step2Desc: 'Analizziamo tutte le opzioni del mercato svizzero',
    step3Title: 'Risparmi senza sforzo',
    step3Desc: 'Gestiamo il cambio completo. Tu firmi solamente',
    ctaTitle: 'Stai pagando troppo per la tua assicurazione?',
    ctaDesc: 'Inviaci la tua polizza attuale e in 24h ti diciamo quanto puoi risparmiare. Gratis e senza impegno.',
    ctaWhatsapp: 'Consulenza gratuita via WhatsApp',
    ctaSchedule: 'Pianifica una chiamata',
    faqTitle: 'Domande Frequenti',
    faqMore: 'Altre domande? Scrivici →',
    reviewsTitle: 'Cosa dicono i nostri clienti',
    reviewsDesc: 'Esperienze reali di famiglie che hanno risparmiato con noi',
    reviewsMore: 'Vedi tutte le recensioni su Google →',
    crossSellTitle: 'Scopri i nostri altri servizi',
    crossSellDesc: 'Tutto ciò di cui un ispanofono ha bisogno in Svizzera, sotto un unico tetto.',
    finalTitle: 'Smetti di pagare troppo. Inizia a risparmiare oggi.',
    finalDesc: 'Ogni mese senza rivedere la tua assicurazione è denaro perso.',
    finalCta: 'Consulenza gratuita via WhatsApp',
    finalBack: 'Vedi servizi ↑',
  },

  digitalPage: {
    seoTitle: 'Soluzioni Digitali Avanzate - Sviluppo Web, CRM, IA & Marketing | Punto Hispano',
    seoDesc: 'Trasformazione digitale completa per aziende in Svizzera: sviluppo web professionale, CRM intelligente, chatbot IA, automazione e marketing digitale.',
    seoKeywords: 'soluzioni digitali svizzera, sviluppo web professionale, CRM aziendale, intelligenza artificiale, chatbot, automazione, marketing digitale, SEO svizzera',
    reviewsTitle: 'COSA DICONO I NOSTRI',
    reviewsAccent: 'CLIENTI',
    reviewsDesc: 'Esperienze reali di aziende che si affidano a Punto Hispano',
  },

  emprendeDigitalPage: {
    seoTitle: 'Soluzioni Digitali per Aziende | Web, CRM, IA | Punto Hispano',
    seoDesc: 'Catalogo completo di servizi digitali: sviluppo web, CRM, chatbot IA, automazione, marketing digitale.',
    backLink: 'Torna a Emprende',
    badge: 'Catalogo Servizi',
    title: 'Soluzioni Digitali',
    subtitle: 'Servizi tecnologici completi per far crescere la tua azienda nel mondo digitale. Dallo sviluppo web all\'intelligenza artificiale.',
    webTitle: 'Sviluppo Web',
    webDesc: 'Siti web moderni, veloci e ottimizzati per convertire visitatori in clienti.',
    ecommerceTitle: 'E-commerce / Negozio Online',
    ecommerceDesc: 'Negozi online completi con gestione prodotti, pagamenti e spedizioni.',
    appTitle: 'Applicazioni Mobile',
    appDesc: 'App native o ibride per iOS e Android con esperienza premium.',
    chatbotTitle: 'Chatbot IA',
    chatbotDesc: 'Automatizza il servizio clienti 24/7 con l\'intelligenza artificiale.',
    automationTitle: 'Automazione dei Processi',
    automationDesc: 'Ottimizza i tuoi flussi di lavoro e risparmia tempo sulle attività ripetitive.',
    marketingTitle: 'Marketing Digitale',
    marketingDesc: 'Strategie di marketing che generano risultati misurabili.',
    whatIncludes: 'Cosa include?',
    additionalTitle: 'Servizi Aggiuntivi',
    additionalDesc: 'Completa il tuo progetto con questi servizi specializzati.',
    customDev: 'Sviluppo su misura',
    customDevDesc: 'Software personalizzato per le tue esigenze',
    graphicDesign: 'Design Grafico',
    graphicDesignDesc: 'Loghi, branding e materiali aziendali',
    seoAudit: 'Audit SEO',
    seoAuditDesc: 'Analisi completa della tua presenza online',
    emailMarketing: 'Email Marketing',
    emailMarketingDesc: 'Campagne email automatizzate',
    socialMedia: 'Social Media',
    socialMediaDesc: 'Gestione e contenuti per i social network',
    techConsulting: 'Consulenza Tech',
    techConsultingDesc: 'Consulenza in tecnologia e trasformazione digitale',
    ctaTitle: 'Hai bisogno di qualcosa di diverso?',
    ctaDesc: 'Se non trovi esattamente quello che cerchi, raccontaci la tua idea e creeremo una soluzione personalizzata.',
    ctaSend: 'Invia il Mio Progetto',
    ctaConsult: 'Consulenza Gratuita',
  },

  viviendasPage: {
    seoTitle: 'Affitto Camere in Svizzera | Punto Hispano',
    seoDesc: 'Camere arredate in Svizzera con WiFi, riscaldamento e servizi inclusi. Contratti flessibili. Assistenza in spagnolo.',
    badgeLoading: 'Caricamento...',
    badgeAvailable: 'alloggi disponibili',
    badgeComingSoon: 'Nuovi alloggi in arrivo',
    heroTitle: 'Trova la tua casa in Svizzera',
    heroDesc: 'Camere e appartamenti arredati per ispanofoni. Tutto incluso, contratti flessibili, supporto in spagnolo.',
    where: 'Dove?',
    allCities: 'Tutte le città',
    checkIn: 'Arrivo',
    checkOut: 'Partenza',
    guests: 'Ospiti',
    guestsAny: 'Qualsiasi',
    guestsPerson: 'persona',
    guestsPersons: 'persone',
    guestsPlus: '4+ persone',
    search: 'Cerca',
    insurance: 'Assicurazione completa',
    noDeposit: 'Senza deposito',
    freeCancellation: 'Cancellazione gratuita',
    wifiIncluded: 'WiFi incluso',
    wifiDesc: 'Internet ad alta velocità',
    waterIncluded: 'Acqua inclusa',
    waterDesc: 'Nessun costo aggiuntivo',
    heating: 'Riscaldamento',
    heatingDesc: 'Climatizzazione completa',
    spanishSupport: 'Supporto spagnolo',
    spanishSupportDesc: 'Attenzione personalizzata',
    filterAll: 'Tutti',
    filterRoom: 'Camera',
    filterDouble: 'Doppia',
    filterStudio: 'Monolocale',
    filterApartment: 'Appartamento completo',
    sortRecommended: 'Consigliati',
    sortPriceAsc: 'Prezzo: crescente',
    sortPriceDesc: 'Prezzo: decrescente',
    sortNewest: 'Più recenti',
    searching: 'Ricerca...',
    showing: 'Mostrando',
    accommodations: 'alloggi',
    noAccommodations: 'Nessun alloggio disponibile al momento',
    sortBy: 'Ordina per:',
    whyChooseUs: 'Perché sceglierci?',
    bestOption: 'La migliore opzione per gli ispanofoni in Svizzera',
  },

  vehiculosPage: {
    seoTitle: 'Noleggio Veicoli in Svizzera | Comparatore Prezzi | Punto Hispano',
    seoDesc: 'Confronta e prenota auto a noleggio in Svizzera. Assicurazione completa, chilometri illimitati e assistenza in spagnolo.',
    badgeText: 'Comparatore Noleggio',
    heroTitle: 'Trova il tuo veicolo ideale',
    heroDesc: 'Confronta i prezzi e prenota online. Assicurazione inclusa, chilometri illimitati e assistenza in spagnolo.',
    trustInsurance: 'Assicurazione completa senza franchigia',
    trustKm: 'Chilometri illimitati inclusi',
    trustGps: 'GPS e assistenza 24/7',
    trustSpanish: 'Assistenza 100% in spagnolo',
    loading: 'Caricamento...',
    loadingFleet: 'Caricamento flotta disponibile...',
    errorTitle: 'Errore nel caricamento dei veicoli',
    errorDesc: 'Per favore riprova più tardi',
    showing: 'Mostrando',
    vehiclesAvailable: 'veicoli disponibili',
    noVehiclesTitle: 'Nessun veicolo per queste date',
    noVehiclesDesc: 'Prova a cambiare le date di ricerca o seleziona un altro luogo di ritiro.',
    changeDates: 'Cambia date',
    clearFilters: 'Pulisci filtri',
    needHelp: 'Hai bisogno di aiuto personalizzato?',
    contactWhatsapp: 'Contatta via WhatsApp',
    filters: 'Filtri',
    ctaTitle: 'Pronto a noleggiare la tua auto?',
    ctaDesc: 'Prenota ora con chilometri illimitati, GPS incluso e assicurazione completa.',
    ctaWhatsapp: 'Prenota via WhatsApp',
    ctaContact: 'Modulo di Contatto',
  },

  relocationPage: {
    seoTitle: 'Pack Relocation Svizzera | Emigrare Senza Rischi | Punto Hispano',
    seoDesc: 'Servizio completo di relocation in Svizzera. Alloggio verificato, pratiche complete, accompagnamento in persona. Da 349 CHF.',
    seoKeywords: 'relocation svizzera, emigrare svizzera, trasloco svizzera, pack relocation, punto hispano',
    breadHome: 'Home',
    breadServices: 'Servizi',
    breadRelocation: 'Pack Relocation',
    badge1: '100% Successo',
    badge2: '+50 Famiglie',
    badge3: '+10 Anni',
    heroTitle: 'Emigrare in Svizzera',
    heroAccent: 'Senza Rischi',
    heroDesc: 'L\'unica consulenza che ti garantisce alloggio verificato, documentazione completa e accompagnamento dal tuo arrivo alla piena integrazione.',
    heroCta: 'Vedi Pacchetti',
    heroWhatsapp: 'Consulenza Gratuita',
    empathyTitle: 'Ti suona familiare?',
    empathyDesc: 'Emigrare è emozionante, ma può anche essere travolgente',
    empathy1Title: 'Arrivare senza sapere da dove iniziare',
    empathy1Desc: 'Non parli la lingua, non conosci il sistema e ogni pratica sembra un labirinto.',
    empathy2Title: 'Paura delle truffe immobiliari',
    empathy2Desc: 'Agenzie fantasma, caparre perse e contratti abusivi sono più comuni di quanto pensi.',
    empathy3Title: 'Documenti che non capisci',
    empathy3Desc: 'Permesso B, assicurazione obbligatoria, registrazione comunale... tutto in tedesco, francese o italiano.',
    empathy4Title: 'Sentirti solo all\'arrivo',
    empathy4Desc: 'Senza rete di supporto, senza sapere a chi chiedere o dove andare quando qualcosa va male.',
    empathyBottom: 'Se qualcosa ti suona familiare, non sei solo.',
    empathyBottomBold: 'Più di 50 famiglie',
    empathyBottomEnd: 'sono già emigrate con noi senza passare per niente di tutto questo.',
    packsTitle: 'Pacchetti di Relocation',
    packsDesc: 'Scegli il pacchetto perfetto per il tuo trasferimento in Svizzera',
    packMostSold: '⭐ Più Venduto',
    processTitle: 'Così Semplice',
    step1Title: 'Raccontaci la tua situazione',
    step1Desc: 'Facciamo una valutazione gratuita per capire cosa ti serve.',
    step2Title: 'Prepariamo tutto',
    step2Desc: 'Documentazione, alloggio verificato, assicurazioni e pratiche: tutto pronto prima del tuo arrivo.',
    step3Title: 'Arrivi e ti godi',
    step3Desc: 'Ti accompagniamo di persona il primo giorno e offriamo supporto esteso.',
    faqTitle: 'Domande Frequenti',
    crossSellTitle: 'Servizi Complementari',
    finalTitle: 'Pronto a fare il passo?',
    finalDesc: 'Più di 50 famiglie sono già emigrate con il nostro aiuto.',
    finalCta: 'Inizia la tua Relocation',
  },

  emprendePage: {
    seoTitle: 'Avvia il tuo business digitale | Sviluppo Web & Soluzioni Digitali | Punto Hispano',
    seoDesc: 'Potenzia il tuo business digitale: sviluppo web, CRM, IA, automazione e marketing.',
    badge: 'Soluzioni Digitali',
    heroTitle1: 'Potenzia il Tuo',
    heroTitle2: ' Business Digitale',
    heroDesc: 'Sviluppo web, intelligenza artificiale, automazione e marketing digitale. Trasformiamo le tue idee in soluzioni tecnologiche.',
    ctaIdea: 'Raccontaci la Tua Idea',
    ctaSolutions: 'Vedi Soluzioni',
    servicesTitle: 'I Nostri Servizi Digitali',
    servicesDesc: 'Soluzioni tecnologiche complete per far crescere il tuo business.',
    svc1Title: 'Sviluppo Web', svc1Desc: 'Siti web moderni e veloci ottimizzati per convertire visitatori in clienti.', svc1F1: 'Design responsive', svc1F2: 'SEO incluso', svc1F3: 'CMS integrato',
    svc2Title: 'Chatbot IA', svc2Desc: 'Automatizza il servizio clienti 24/7 con l\'IA.', svc2F1: 'Risposte naturali', svc2F2: 'Multilingua', svc2F3: 'Integrazione CRM',
    svc3Title: 'Automazione', svc3Desc: 'Ottimizza i tuoi processi aziendali.', svc3F1: 'Workflow', svc3F2: 'Integrazioni', svc3F3: 'Report automatici',
    svc4Title: 'App Mobile', svc4Desc: 'Applicazioni native o ibride per iOS e Android.', svc4F1: 'UI/UX premium', svc4F2: 'Notifiche push', svc4F3: 'Modalità offline',
    svc5Title: 'Marketing Digitale', svc5Desc: 'Strategie di marketing con risultati misurabili.', svc5F1: 'SEO & SEM', svc5F2: 'Social Media', svc5F3: 'Email Marketing',
    svc6Title: 'E-commerce', svc6Desc: 'Negozi online completi con pagamenti e gestione inventario.', svc6F1: 'Pagamenti sicuri', svc6F2: 'Gestione magazzino', svc6F3: 'Spedizioni automatizzate',
    processTitle: 'Come Lavoriamo',
    processDesc: 'Un processo chiaro e trasparente dalla tua idea al prodotto finale.',
    proc1: 'Raccontaci la tua idea', proc1Desc: 'Descrivi il tuo progetto e i tuoi obiettivi.',
    proc2: 'Analisi e proposta', proc2Desc: 'Valutiamo la fattibilità tecnica e presentiamo una proposta dettagliata.',
    proc3: 'Sviluppo', proc3Desc: 'Costruiamo la tua soluzione con metodologie agili.',
    proc4: 'Lancio', proc4Desc: 'Pubblichiamo il tuo progetto e ti accompagniamo nel lancio.',
    card1Title: 'Condividi la Tua Idea', card1Desc: 'Hai un progetto in mente? Raccontacelo.', card1Cta: 'Invia Idea',
    card2Title: 'Guadagna Online', card2Desc: 'Impara a monetizzare le tue competenze.', card2Cta: 'Vedi Guide',
    card3Title: 'Collabora con Noi', card3Desc: 'Unisciti al nostro programma partner.', card3Cta: 'Diventa Partner',
    finalTitle: 'Pronto a Digitalizzare il Tuo Business?',
    finalDesc: 'Contattaci oggi e scopri come possiamo aiutarti a crescere nel mondo digitale.',
    finalWhatsapp: 'Contatta via WhatsApp',
    finalSchedule: 'Prenota Consulenza',
  },

  politicasPage: {
    seoTitle: 'Politiche & Documenti Legali | Punto Hispano',
    seoDesc: 'Documentazione legale, politiche sulla privacy, cookie e termini di utilizzo di Punto Hispano.',
    title: 'Politiche & Documenti Legali',
    subtitle: 'Trasparenza e conformità normativa in tutti i nostri servizi',
    commitmentTitle: 'Impegno di Trasparenza',
    commitmentDesc: 'In Punto Hispano ci impegniamo a mantenere la piena trasparenza su come operiamo, come trattiamo i vostri dati e quali diritti avete come utenti.',
    avisoLegal: 'Avviso Legale',
    avisoLegalDesc: 'Informazioni sull\'ente titolare di questo sito, condizioni generali d\'uso e diritti di proprietà intellettuale.',
    privacidad: 'Politica sulla Privacy',
    privacidadDesc: 'Informazioni dettagliate su come raccogliamo, utilizziamo, condividiamo e proteggiamo i vostri dati personali.',
    cookies: 'Politica sui Cookie',
    cookiesDesc: 'Informazioni sui cookie utilizzati, il loro scopo e come configurare le vostre preferenze.',
    gdpr: 'Politica GDPR',
    gdprDesc: 'Informazioni complete sulla protezione dei dati personali secondo il GDPR e i vostri diritti.',
    questionTitle: 'Avete domande aggiuntive?',
    questionDesc: 'Per qualsiasi domanda sulle nostre politiche, contattate il nostro Responsabile della Protezione dei Dati a',
    lastUpdate: 'Ultimo aggiornamento delle nostre politiche: 5 maggio 2025',
  },

  faqPage: {
    seoTitle: 'Domande Frequenti | Punto Hispano',
    seoDesc: 'Risposte alle domande più frequenti sui nostri servizi in Svizzera.',
    title: 'Domande Frequenti',
    subtitle: 'Risposte alle domande più comuni sui nostri servizi',
    notFound: 'Non trovi risposta alla tua domanda? Non esitare a contattarci.',
    phone: 'Telefono',
    email: 'Email',
    cat1: 'Generali',
    cat2: 'Gestione & Amministrazione',
    cat3: 'Consulenza Legale',
    cat4: 'Corsi di Lingue',
    cat5: 'Traduzioni Ufficiali',
    cat6: 'Web Design & Hosting',
    cat7: 'Consulenza Assicurativa',
    cat8: 'Soluzioni Digitali',
    q1_1: 'Quali servizi offre Punto Hispano?', a1_1: 'Punto Hispano offre un\'ampia gamma di servizi professionali: gestione amministrativa, consulenza legale, corsi di lingue, traduzioni ufficiali, web design, consulenza assicurativa e soluzioni digitali.',
    q1_2: 'In quali lingue offrite i vostri servizi?', a1_2: 'I nostri servizi sono disponibili principalmente in spagnolo, ma serviamo anche in tedesco, inglese e italiano.',
    q1_3: 'Come posso richiedere un preventivo?', a1_3: 'Potete richiedere un preventivo tramite il nostro modulo di contatto, chiamando il +41 77 231 72 88 o inviando un\'email a info@puntohispano.ch.',
    q1_4: 'Avete servizi personalizzati per le aziende?', a1_4: 'Sì, offriamo soluzioni personalizzate per le aziende in tutti i nostri settori di servizio.',
    q1_5: 'Dove si trova il vostro ufficio principale?', a1_5: 'Il nostro ufficio principale si trova a Thurgauerstrasse 117, 8152 Opfikon, Zurigo, Svizzera.',
    q2_1: 'Cosa include il servizio di creazione d\'impresa?', a2_1: 'Il nostro servizio include consulenza sulla forma giuridica, preparazione documenti, registro di commercio, iscrizione fiscale e procedure di sicurezza sociale.',
    q2_2: 'Come funziona la pianificazione fiscale?', a2_2: 'Realizziamo un\'analisi personalizzata della vostra situazione fiscale e vi consigliamo sulle deduzioni e benefici fiscali applicabili.',
    q2_3: 'Potete gestire la mia dichiarazione dei redditi?', a2_3: 'Sì, offriamo un servizio completo di gestione delle dichiarazioni fiscali per privati.',
    q3_1: 'Quali documenti servono per il ricongiungimento familiare?', a3_1: 'Per il ricongiungimento familiare sono generalmente necessari: permesso di soggiorno, atti di matrimonio/nascita legalizzati, prova di mezzi finanziari sufficienti e contratto d\'affitto.',
    q3_2: 'Offrite consulenza sul diritto del lavoro svizzero?', a3_2: 'Sì, forniamo consulenza completa sul diritto del lavoro svizzero, inclusa revisione contratti, licenziamenti e controversie.',
    q4_1: 'Qual è il prezzo dei corsi di tedesco?', a4_1: 'I prezzi variano secondo il livello e la modalità. Da CHF 40/ora in gruppo a CHF 90/sessione in privato.',
    q4_2: 'Posso avere una lezione di prova?', a4_2: 'Sì, offriamo una lezione di prova gratuita per conoscere la nostra metodologia.',
    q5_1: 'Le vostre traduzioni sono valide per le procedure ufficiali?', a5_1: 'Sì, le nostre traduzioni ufficiali sono realizzate da traduttori giurati e sono valide presso gli organismi ufficiali.',
    q5_2: 'Quanto tempo ci vuole per una traduzione giurata?', a5_2: 'I documenti standard richiedono generalmente 2-3 giorni lavorativi. Servizio express disponibile per le urgenze.',
    q6_1: 'Cosa include il pacchetto sito web professionale?', a6_1: 'Include: design personalizzato di 5-7 pagine, design responsive, SEO base, integrazione Analytics, modulo contatto, hosting un anno e manutenzione 3 mesi.',
    q6_2: 'Posso aggiornare il mio sito autonomamente?', a6_2: 'Sì, implementiamo un CMS che permette di aggiornare facilmente testi, immagini e sezioni.',
    q7_1: 'Come posso ridurre il mio premio assicurativo sanitario?', a7_1: 'Ci sono diverse strategie: regolare la franchigia, scegliere un modello HMO, verificare i sussidi cantonali o combinare diverse coperture.',
    q7_2: 'Quali assicurazioni sono obbligatorie in Svizzera?', a7_2: 'L\'assicurazione sanitaria di base (LAMal) è obbligatoria per tutti i residenti. L\'assicurazione RC è obbligatoria per i proprietari di veicoli.',
    q8_1: 'Cos\'è un CRM e come può aiutare la mia azienda?', a8_1: 'Un CRM permette di gestire centralmente le relazioni con i clienti con vantaggi come migliore organizzazione dei dati e automazione delle vendite.',
    q8_2: 'Quali soluzioni IA offrite per le piccole imprese?', a8_2: 'Offriamo chatbot 24/7, automazione delle attività amministrative, analisi predittiva dei dati e assistenti virtuali per la pianificazione.',
  },

  contactoPage: {
    seoTitle: 'Contatto | Amministrazione & Consulenza in Svizzera | Punto Hispano',
    seoDesc: 'Scrivici su WhatsApp o email o prenota un appuntamento a Zurigo. Risposta rapida.',
    heroTitle: 'Parliamo',
    heroDesc: 'Il nostro team di professionisti bilingui è pronto ad assisterti. Scegli il tuo metodo di contatto preferito.',
    whatsappBtn: 'WhatsApp Diretto',
    formBtn: 'Modulo di Contatto',
    formTitle: 'Modulo di Contatto',
    successTitle: 'Messaggio Inviato!',
    successDesc: 'Grazie per averci contattato. Abbiamo ricevuto il tuo messaggio e ti risponderemo entro 24 ore.',
    sendAnother: 'Invia un altro messaggio',
    labelName: 'Nome Completo',
    placeholderName: 'Inserisci il tuo nome completo',
    labelEmail: 'Indirizzo Email',
    placeholderEmail: 'tua.email@esempio.com',
    labelPhone: 'Telefono (opzionale)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelService: 'Area di Servizio',
    selectService: "Seleziona un'area",
    optGestoria: 'Amministrazione & Fiscalità',
    optLegal: 'Consulenza Legale',
    optIdiomas: 'Corsi di Lingue',
    optSeguros: 'Assicurazioni & Previdenza',
    optDigital: 'Soluzioni Digitali',
    optOther: 'Altro',
    labelMessage: 'Il Tuo Messaggio',
    placeholderMessage: 'Raccontaci come possiamo aiutarti...',
    sending: 'Invio in corso...',
    sendBtn: 'Invia Messaggio',
    toastSuccess: 'Modulo inviato',
    toastSuccessDesc: 'Abbiamo ricevuto il tuo messaggio. Ti contatteremo presto.',
    toastError: "Errore nell'invio",
    toastErrorDesc: "Si è verificato un problema durante l'invio. Riprova.",
    infoTitle: 'Informazioni di Contatto',
    infoDesc: 'Il nostro team multilingue è pronto ad assisterti in italiano, spagnolo e inglese.',
    officeTitle: 'Il Nostro Ufficio',
    phoneTitle: 'Telefono',
    whatsappTitle: 'WhatsApp Diretto',
    emailTitle: 'Email',
    hoursTitle: 'Orari di Apertura',
    monFri: 'Lunedì - Venerdì',
    sat: 'Sabato',
    sun: 'Domenica',
    closed: 'Chiuso',
    needHelp: 'Hai bisogno di aiuto immediato?',
    needHelpDesc: 'Contattaci direttamente su WhatsApp per assistenza rapida',
    validName: 'Il nome deve avere almeno 2 caratteri',
    validEmail: 'Inserisci un indirizzo email valido',
    validService: "Seleziona un'area di servizio",
    validMessage: 'Il messaggio deve avere almeno 10 caratteri',
  },

  contactoFormPage: {
    seoTitle: 'Modulo di Contatto | Punto Hispano',
    seoDesc: 'Contattaci per informazioni sui nostri servizi. Rispondiamo entro 24-48 ore lavorative.',
    title: 'Modulo di Contatto',
    subtitle: 'Compila il modulo sottostante per inviarci la tua richiesta. Il nostro team ti risponderà il prima possibile.',
    successTitle: 'Messaggio Inviato!',
    successDesc: 'Grazie per averci contattato. Ti risponderemo entro 24-48 ore lavorative.',
    sendAnother: 'Invia un altro messaggio',
    labelName: 'Nome completo',
    placeholderName: 'Inserisci il tuo nome',
    labelEmail: 'Indirizzo email',
    labelPhone: 'Telefono (opzionale)',
    placeholderPhone: 'Il tuo numero di telefono',
    labelService: 'Area di servizio',
    selectService: "Seleziona un'area",
    optGestoria: 'Amministrazione',
    optLegal: 'Consulenza Legale',
    optIdiomas: 'Corsi di Lingue',
    optSeguros: 'Assicurazioni & Previdenza',
    optDigital: 'Soluzioni Digitali',
    optCoches: 'Noleggio Auto',
    optViviendas: 'Affitto Alloggi',
    labelMessage: 'Messaggio',
    placeholderMessage: 'Come possiamo aiutarti?',
    sending: 'Invio...',
    sendBtn: 'Invia Messaggio',
    privacyText: 'Inviando questo modulo, accetti la nostra',
    privacyLink: 'informativa sulla privacy',
    privacyEnd: 'e il trattamento dei tuoi dati per rispondere alla tua richiesta.',
    fastResponse: 'Risposta rapida',
    fastResponseDesc: '24-48h lavorative',
    noCommitment: 'Senza impegno',
    noCommitmentDesc: 'Preventivi personalizzati',
    spanishSupport: 'Supporto multilingue',
    spanishSupportDesc: 'Team multilingue professionale',
  },

  oficinasPage: {
    seoTitle: 'Ufficio Opfikon | Punto Hispano',
    seoDesc: 'Visita il nostro ufficio a Opfikon, Zurigo. Posizione, orari, trasporti.',
    heroTitle: 'Il Nostro Ufficio a Opfikon',
    heroDesc: 'Visitaci al centro commerciale TMC, a pochi minuti dal centro di Zurigo.',
    howToFind: 'Come Trovarci — Passo dopo Passo',
    step1Title: "Cerca l'edificio TMC",
    step1Desc: 'È un centro commerciale alla Thurgauerstrasse 117. Vedrai l\'insegna "TMC" sulla facciata.',
    step2Title: 'Entra e vai dritto',
    step2Desc: "Entra dalla porta principale e vai dritto fino a quando vedi un bar.",
    step3Title: 'Sali al 1° piano',
    step3Desc: "Accanto al bar troverai l'ascensore. Sali al primo piano.",
    step4Title: 'Gira a destra',
    step4Desc: "Uscendo dall'ascensore, gira a destra. Il nostro ufficio è il 181.",
    tmcNote: "Siamo all'interno del TMC (Trade Mart Center), un edificio di showroom e uffici.",
    enlargeMap: 'Ingrandisci Mappa',
    addressTitle: 'Indirizzo',
    phoneTitle: 'Telefono',
    emailTitle: 'Email',
    hoursTitle: 'Orari di Apertura',
    appointmentsTitle: 'Appuntamenti',
    appointmentsDesc: 'Per un servizio migliore, ti consigliamo di fissare un appuntamento.',
    requestAppointment: 'Richiedi Appuntamento',
    howToGet: 'Come Arrivare',
    train: 'Treno',
    trainDesc: 'Stazione di Opfikon, 5 minuti a piedi',
    bus: 'Bus',
    busDesc: 'Linee 759, 781 - Fermata Thurgauerstrasse',
    car: 'Auto',
    carDesc: "Parcheggio disponibile nell'edificio",
    airport: "Dall'aeroporto",
    airportDesc: '10 minuti in taxi o bus diretto',
    parkingTitle: 'Parcheggio',
    parkingDesc: "L'edificio TMC dispone di parcheggio orario per i clienti. In alternativa, parcheggio pubblico nelle vicinanze.",
    additionalInfo: 'Informazioni Aggiuntive',
    accessibilityTitle: 'Accessibilità',
    accessibilityDesc: "I nostri uffici sono accessibili a persone con mobilità ridotta. L'edificio ha ascensori e rampe.",
    walkInsTitle: 'Visite senza appuntamento',
    walkInsDesc: 'Consigliamo di fissare un appuntamento, ma accettiamo visite in base alla disponibilità.',
    nearbyTitle: 'Servizi vicini',
    nearbyDesc: "All'interno dell'edificio TMC troverai un bar dove aspettare comodamente.",
    otherContactTitle: 'Preferisci contattarci in altro modo?',
    otherContactDesc: 'Se non puoi visitarci di persona, sono disponibili altre opzioni di contatto.',
    contactForm: 'Modulo di Contatto',
    whatsappChat: 'WhatsApp & Chat',
    days: ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'],
    satHours: '10:00 - 14:00 (su appuntamento)',
    closed: 'Chiuso',
  },

  quienesSomosPage: {
    seoTitle: 'Chi Siamo - Punto Hispano | Servizi Professionali in Svizzera',
    seoDesc: 'Scopri Punto Hispano: 12+ anni al servizio della comunità in Svizzera. Amministrazione, assicurazioni, legale, lingue e servizi digitali.',
    badge: 'Chi Siamo',
    heroTitle: 'Punto Hispano:',
    heroAccent: 'Il tuo ponte tra la Svizzera e il mondo',
    heroDesc: 'Dal 2013, facilitiamo l\'integrazione e il successo in territorio svizzero.',
    stat1: 'Clienti Soddisfatti',
    stat2: 'Pratiche Completate',
    stat3: 'Aziende Create',
    stat4: 'Anni di Esperienza',
    missionBtn: 'La Nostra Missione & Visione',
    contactBtn: 'Contattaci',
    teamPhoto: 'Il Nostro Team',
    teamPhotoDesc: 'Professionisti dedicati al tuo successo',
    historyTitle: 'La Nostra Storia',
    historySubtitle: 'Un percorso di crescita e impegno',
    historyDesc: 'Scopri come Punto Hispano si è evoluto dai suoi inizi fino a diventare il riferimento in Svizzera.',
    timeline2013Title: 'Gli inizi',
    timeline2013Desc: 'Santiago Castillo, il fondatore, ha iniziato in Svizzera con assicurazioni e 3° pilastro.',
    timeline2019Title: 'Servizi senza ufficio',
    timeline2019Desc: 'Punto Hispano ha iniziato a offrire servizi professionali alla comunità.',
    timeline2023Title: 'Apertura ufficio',
    timeline2023Desc: 'Punto Hispano ha aperto il suo ufficio fisico, un traguardo importante.',
    timeline2025Title: 'Espansione continua',
    timeline2025Desc: 'Continuiamo ad ampliare i nostri servizi e a consolidare la nostra posizione di riferimento.',
    teamTitle: 'Il Nostro Team & Ufficio',
    teamSubtitle: 'Le persone dietro Punto Hispano',
    teamDesc: 'Conosci Santiago Castillo, il nostro fondatore, e il team professionale.',
    founderBadge: 'Fondatore',
    valuesTitle: 'I Nostri Valori',
    valuesSubtitle: 'I principi che ci guidano',
    valuesDesc: 'Ogni valore rappresenta un impegno reale verso i nostri clienti e la comunità.',
    val1Title: 'Vicinanza',
    val1Desc: 'Attenzione personalizzata e adattata ad ogni cliente.',
    val2Title: 'Professionalità',
    val2Desc: 'Rigore, eccellenza e miglioramento continuo.',
    val3Title: 'Trasparenza',
    val3Desc: 'Comunicazione chiara e onesta.',
    val4Title: 'Innovazione',
    val4Desc: 'Ricerca costante di soluzioni creative ed efficienti.',
    val5Title: 'Impegno',
    val5Desc: 'Dedizione assoluta alla soddisfazione e al successo dei clienti.',
    val6Title: 'Integrazione',
    val6Desc: 'Facilitiamo il legame tra le culture.',
    ctaTitle: 'Pronto a fare il primo passo?',
    ctaDesc: 'Contattaci oggi per una consulenza gratuita.',
    ctaBtn: 'Richiedi Consulenza Gratuita',
    ctaSecondary: 'Vedi i Nostri Servizi',
  },

  misionVisionPage: {
    seoTitle: 'Missione & Visione - Punto Hispano | Leader nei Servizi Professionali in Svizzera',
    seoDesc: 'Scopri la missione, visione e valori di Punto Hispano: 12+ anni al vertice dei servizi professionali in Svizzera.',
    badge: 'Il Nostro Scopo',
    heroTitle: 'Missione &',
    heroAccent: 'Visione',
    heroDesc: 'Scopri cosa ci spinge ad essere il riferimento nei servizi professionali in Svizzera',
    stat1: 'Clienti soddisfatti',
    stat2: 'Anni di esperienza',
    stat3: 'Impegno per la qualità',
    stat4: 'Pilastri di servizio',
    missionTitle: 'La Nostra Missione',
    missionSubtitle: 'Cosa facciamo ogni giorno',
    missionText1: 'Fornire servizi professionali completi della massima qualità alla comunità in Svizzera.',
    missionText2: 'Ci impegniamo ad essere un ponte affidabile tra le culture.',
    missionPoints: ['Servizi professionali completi', 'Facilitiamo l\'integrazione in Svizzera', 'Sviluppo professionale e benessere personale', 'Soluzioni efficienti e personalizzate', 'Ponte affidabile tra le culture', 'Accompagnamento vicino nella tua lingua'],
    commitmentTitle: 'Impegno Quotidiano',
    commitmentDesc: 'Ogni giorno lavoriamo per realizzare la nostra missione.',
    visionTitle: 'La Nostra Visione',
    visionSubtitle: 'Verso dove andiamo',
    visionText1: 'Essere riconosciuti come l\'azienda leader nei servizi professionali in Svizzera.',
    visionText2: 'Aspiriamo a trasformare l\'esperienza dei clienti in Svizzera.',
    visionPoints: ['Azienda leader nei servizi', 'Eccellenza e innovazione tecnologica', 'Approccio umano e personalizzato', 'Integrazione perfetta di servizi tradizionali e digitali', 'Ecosistema completo di soluzioni', 'Trasformazione dell\'esperienza del cliente'],
    futureTitle: 'Futuro Brillante',
    futureDesc: 'Costruiamo il futuro dei servizi professionali in Svizzera.',
    valuesTitle: 'Valori che Ci Definiscono',
    valuesSubtitle: 'I principi fondamentali che guidano ogni decisione.',
    val1Title: 'Vicinanza',
    val1Desc: 'Trattamento personale e umano',
    val2Title: 'Fiducia',
    val2Desc: 'Trasparenza totale',
    val3Title: 'Eccellenza',
    val3Desc: 'Qualità superiore',
    val4Title: 'Innovazione',
    val4Desc: 'Tecnologia avanzata',
    ctaTitle: 'Pronto a far parte della nostra storia?',
    ctaDesc: 'Unisciti a oltre 2500 clienti che si affidano a Punto Hispano.',
    ctaBtn: 'Consulenza Gratuita',
    ctaSecondary: 'Vedi i Servizi',
  },

  valoresPage: {
    seoTitle: 'Valori Aziendali - Punto Hispano | Eccellenza, Fiducia & Innovazione',
    seoDesc: 'Scopri i valori fondamentali di Punto Hispano: eccellenza, fiducia, specializzazione, integrità, innovazione ed empatia.',
    badge: 'La Nostra Filosofia',
    heroTitle: 'I Nostri',
    heroAccent: 'Valori',
    heroDesc: 'I principi fondamentali che definiscono la nostra identità e guidano ogni decisione.',
    stat1: 'Anni di esperienza',
    stat2: 'Clienti soddisfatti',
    stat3: 'Pilastri di servizio',
    stat4: 'Impegno per la qualità',
    val1Title: 'Eccellenza',
    val1Desc: 'Cerchiamo la massima qualità in ogni servizio.',
    val2Title: 'Fiducia',
    val2Desc: 'Costruiamo relazioni durature basate sulla trasparenza e l\'onestà.',
    val3Title: 'Specializzazione',
    val3Desc: 'Manteniamo una conoscenza approfondita e aggiornata dei nostri ambiti di servizio.',
    val4Title: 'Integrità',
    val4Desc: 'Agiamo con rettitudine ed etica professionale.',
    val5Title: 'Innovazione',
    val5Desc: 'Integriamo costantemente nuove tecnologie e metodi.',
    val6Title: 'Empatia',
    val6Desc: 'Comprendiamo le esigenze e le circostanze uniche di ogni cliente.',
    learnMore: 'Scopri di più',
    commitmentTitle: 'Il Nostro Impegno Incrollabile',
    commitmentText1: 'In Punto Hispano, questi valori non sono semplici parole, ma principi viventi.',
    commitmentText2: 'Ci impegniamo fermamente a mantenere i più alti standard di qualità e etica professionale.',
    promiseLabel: 'La nostra promessa:',
    promiseText: 'Ogni giorno lavoriamo per essere il riferimento di fiducia, eccellenza e vicinanza che la comunità in Svizzera merita e necessita.',
    meetTeam: 'Conosci il nostro team',
    actionTitle: 'Valori in Azione',
    actionSubtitle: 'Scopri come i nostri valori si traducono in benefici tangibili.',
    qualityTitle: 'Garanzia di Qualità',
    qualityDesc: 'Il nostro impegno per l\'eccellenza si riflette in ogni servizio che forniamo.',
    qualityItems: ['Attenzione personalizzata e dedicata', 'Monitoraggio continuo di tutti i processi', 'Trasparenza totale nella nostra gestione'],
    closenessTitle: 'Vicinanza Umana',
    closenessDesc: 'Capiamo che dietro ogni pratica c\'è una persona con sogni e bisogni unici.',
    closenessItems: ['Comunicazione nella tua lingua madre', 'Comprensione della tua cultura e contesto', 'Supporto emotivo nei processi complessi'],
  },

  carrerasPage: {
    seoTitle: 'Lavora con Noi presso Punto Hispano Svizzera',
    seoDesc: 'Scopri le opportunità di carriera in Punto Hispano: amministrazione, legale, lingue, assicurazioni e digitale.',
    badge: 'Opportunità di Carriera',
    heroTitle: 'Lavora con',
    heroAccent: 'Noi',
    heroDesc: 'Unisciti al team leader nei servizi professionali in Svizzera.',
    stat1: 'Clienti soddisfatti',
    stat2: 'Anni di esperienza',
    stat3: 'Professionisti + collaboratori esterni',
    stat4: 'Aree di specializzazione',
    benefitsTitle: 'Perché scegliere Punto Hispano?',
    benefitsSubtitle: 'Scopri i vantaggi di far parte del nostro team professionale',
    ben1Title: 'Ambiente Multiculturale',
    ben1Desc: 'Lavora in un ambiente collaborativo con professionisti di diverse nazionalità',
    ben2Title: 'Crescita Professionale',
    ben2Desc: 'Reali opportunità di sviluppo e promozione interna',
    ben3Title: 'Formazione Continua',
    ben3Desc: 'Supporto per certificazioni e aggiornamento professionale costante',
    ben4Title: 'Equilibrio Vita-Lavoro',
    ben4Desc: 'Orari flessibili e rispetto del tuo tempo personale',
    ben5Title: 'Benefici Sociali',
    ben5Desc: 'Assicurazione sanitaria, piani pensionistici e benefit aggiuntivi',
    ben6Title: 'Riconoscimento',
    ben6Desc: 'Sistema di incentivi e riconoscimento per performance eccezionali',
    joinTitle: 'Unisciti al Team',
    joinSubtitle: 'La tua prossima opportunità professionale ti aspetta',
    joinText1: 'In Punto Hispano cerchiamo talento impegnato con attitudine positiva e vocazione al servizio.',
    joinText2: 'Fai parte dell\'azienda leader nei servizi professionali in Svizzera.',
    processTitle: 'Processo di Selezione:',
    processSteps: ['Invio CV e lettera di presentazione', 'Revisione candidature e preselezione', 'Colloquio iniziale con HR', 'Colloquio tecnico con il team', 'Proposta di assunzione'],
    sendCV: 'Invia il tuo CV',
    areasTitle: 'Aree di Specializzazione',
    areasSubtitle: 'Scopri le diverse aree dove puoi sviluppare la tua carriera',
    area1Title: 'Amministrazione Fiscale',
    area1Desc: 'Specialisti in dichiarazioni fiscali, contabilità e consulenza tributaria.',
    area1Req: 'Esperienza in fiscalità svizzera/internazionale, laurea in economia o simile.',
    area2Title: 'Consulenza Legale',
    area2Desc: 'Professionisti del diritto specializzati in immigrazione, lavoro, civile e commerciale.',
    area2Req: 'Laurea in giurisprudenza, esperienza in consulenza legale internazionale.',
    area3Title: 'Insegnamento Lingue',
    area3Desc: 'Insegnanti madrelingua per lezioni individuali e di gruppo.',
    area3Req: 'Titolo ufficiale di insegnamento lingue, certificazioni (DELE, Goethe, Cambridge).',
    area4Title: 'Consulenza Assicurativa',
    area4Desc: 'Consulenti specializzati in assicurazione sanitaria, vita e piani pensionistici.',
    area4Req: 'Certificazione come consulente assicurativo, esperienza nel mercato svizzero.',
    area5Title: 'Sviluppo Digitale',
    area5Desc: 'Designer e sviluppatori web, specialisti UX/UI e marketing digitale.',
    area5Req: 'Formazione tecnica, portfolio progetti, conoscenze aggiornate.',
    area6Title: 'Vendite & Marketing',
    area6Desc: 'Professionisti focalizzati sull\'acquisizione clienti e strategie di posizionamento.',
    area6Req: 'Esperienza commerciale B2B, eccezionali capacità comunicative.',
    reqLabel: 'Requisiti:',
  },

  notFoundPage: {
    title: 'Pagina non trovata',
    desc: 'Ci dispiace, la pagina che cerchi non esiste o è stata spostata.',
    goHome: "Torna alla home",
  },

  recursosPage: {
    seoTitle: 'Risorse Gratuite | Guide, Strumenti & Webinar | Punto Hispano',
    seoDesc: 'Accedi a guide, calcolatori, webinar e risorse gratuite per il tuo successo in Svizzera.',
    heroTitle: 'Centro Risorse',
    heroSubtitle: 'Strumenti, guide e materiali gratuiti per il tuo successo in Svizzera',
    searchPlaceholder: 'Cerca risorse...',
    filterAll: 'Tutti',
    filterGuides: 'Guide',
    filterCalculators: 'Calcolatori',
    filterWebinars: 'Webinar',
    filterVideos: 'Video',
    filterTemplates: 'Modelli',
    categoryAll: 'Tutte le categorie',
    categoryLegal: 'Legale',
    categoryFiscal: 'Fiscale',
    categorySeguros: 'Assicurazioni',
    categoryIdiomas: 'Lingue',
    categoryDigital: 'Digitale',
    sortPopular: 'Più popolari',
    sortRecent: 'Più recenti',
    sortRating: 'Meglio valutati',
    downloads: 'download',
    pages: 'pagine',
    downloadBtn: 'Scarica',
    previewBtn: 'Anteprima',
    featured: 'In evidenza',
    new: 'Nuovo',
    noResults: 'Nessuna risorsa trovata con i filtri selezionati.',
    clearFilters: 'Reimposta filtri',
    newsletterTitle: 'Vuoi ricevere nuove risorse?',
    newsletterDesc: 'Iscriviti e ricevi guide e strumenti direttamente nella tua email.',
    newsletterBtn: 'Iscriviti',
    emailPlaceholder: 'tua@email.com',
  },

  guiasPracticasPage: {
    seoTitle: 'Guide Pratiche | Risorse | Punto Hispano',
    seoDesc: 'Guide dettagliate su procedure e processi in Svizzera.',
    title: 'Guide Pratiche',
    subtitle: 'Informazioni utili per le tue pratiche e gestioni',
    readTime: 'Tempo di lettura',
    readGuide: 'Leggi la guida',
    faqTitle: 'Domande Frequenti sulle nostre Guide',
  },

  whitepapersPage: {
    seoTitle: 'Whitepapers | Risorse Professionali | Punto Hispano',
    seoDesc: 'Scarica i nostri whitepapers specializzati su fiscalità, diritto e trasformazione digitale.',
    title: 'Whitepapers',
    subtitle: 'Documenti tecnici e guide professionali',
    pages: 'pagine',
    published: 'Pubblicato',
    downloadPdf: 'Scarica PDF',
    faqTitle: 'Domande Frequenti sui nostri Whitepapers',
  },

  videosWebinarsPage: {
    seoTitle: 'Video & Webinar | Risorse Audiovisive | Punto Hispano',
    seoDesc: 'Accedi ai nostri webinar e contenuti audiovisivi su procedure, tasse e vita in Svizzera.',
    title: 'Video & Webinar',
    subtitle: 'Contenuto audiovisivo educativo e professionale',
    upcoming: 'In programma',
    past: 'Passati',
    register: 'Registrati',
    watchNow: 'Guarda ora',
    duration: 'Durata',
    faqTitle: 'Domande Frequenti sui nostri Webinar',
  },

  colaboraPage: {
    seoTitle: 'Programma Partner e Collaboratori | Punto Hispano',
    seoDesc: 'Unisciti al nostro programma partner: affiliati, partner tecnologici e agenzie.',
    heroTitle: 'Programma Partner e Collaboratori',
    heroDesc: 'Unisciti al nostro ecosistema e cresci insieme.',
    backToEmprende: 'Torna a Emprende',
    whyPartner: 'Perché diventare Partner?',
    whyPartnerDesc: 'Vantaggi esclusivi del nostro ecosistema di collaborazione.',
    ben1Title: 'Commissioni Attraenti',
    ben1Desc: 'Guadagna commissioni competitive per ogni referral o progetto congiunto.',
    ben2Title: 'Supporto Dedicato',
    ben2Desc: 'Team di supporto esclusivo per partner con priorità.',
    ben3Title: 'Formazione Continua',
    ben3Desc: 'Accesso a risorse e formazioni esclusive per partner.',
    ben4Title: 'Crescita Congiunta',
    ben4Desc: 'Fai crescere la tua attività insieme alla nostra con sinergie reali.',
    ctaTitle: 'Pronto a diventare nostro Partner?',
    ctaBtn: 'Richiedi Partnership',
    ctaWhatsapp: 'Chiedi via WhatsApp',
  },

  ganaDineroPage: {
    seoTitle: 'Guadagna Online | Strategie Digitali | Punto Hispano',
    seoDesc: 'Impara a monetizzare le tue competenze e creare entrate digitali dalla Svizzera.',
    heroTitle: 'Guadagna Online',
    heroDesc: 'Strategie comprovate per generare entrate nel mondo digitale.',
    backToEmprende: 'Torna a Emprende',
    strategiesTitle: 'Strategie per Generare Entrate',
    strategiesDesc: 'Scopri i modi migliori per guadagnare online.',
    tipsLabel: 'Consigli chiave:',
    ctaTitle: 'Hai bisogno di aiuto per iniziare?',
    ctaDesc: 'Ti consigliamo per lanciare la tua attività digitale.',
    ctaBtn: 'Consulenza Gratuita',
    ctaWhatsapp: 'WhatsApp',
  },

  transmiteIdeasPage: {
    seoTitle: 'Invia la Tua Idea di Progetto | Punto Hispano',
    seoDesc: 'Raccontaci la tua idea di progetto digitale e ti aiuteremo a realizzarla.',
    heroTitle: 'Raccontaci la Tua Idea',
    heroDesc: 'Descrivi il tuo progetto e il nostro team ti consiglierà su come realizzarlo.',
    backToEmprende: 'Torna a Emprende',
    formTitle: 'Descrivi il tuo progetto',
    labelName: 'Nome completo',
    placeholderName: 'Il tuo nome',
    labelEmail: 'Indirizzo email',
    labelPhone: 'Telefono (opzionale)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelProjectType: 'Tipo di progetto',
    labelDescription: 'Descrivi la tua idea',
    placeholderDescription: 'Raccontaci i dettagli del tuo progetto...',
    labelBudget: 'Budget stimato',
    labelUrgency: 'Urgenza',
    labelFeatures: 'Funzionalità richieste',
    submitBtn: 'Invia Idea',
    sending: 'Invio...',
    successTitle: 'Idea Ricevuta!',
    successDesc: 'Abbiamo ricevuto la tua proposta. Ti contatteremo per valutare il tuo progetto.',
    sendAnother: 'Invia un\'altra idea',
    guaranteeTitle: 'Il nostro impegno',
    guarantee1: 'Risposta in 24-48h',
    guarantee2: 'Valutazione gratuita',
    guarantee3: 'Senza impegno',
    guarantee4: 'Preventivo dettagliato',
  },

  authPage: {
    loginTitle: 'Accedi',
    loginDesc: 'Accedi al tuo account Punto Hispano.',
    signupTitle: 'Crea Account',
    signupDesc: 'Registrati per accedere a tutti i nostri servizi.',
    email: 'Indirizzo email',
    password: 'Password',
    confirmPassword: 'Conferma password',
    name: 'Nome completo',
    loginBtn: 'Accedi',
    signupBtn: 'Crea Account',
    forgotPassword: 'Password dimenticata?',
    noAccount: 'Non hai un account?',
    hasAccount: 'Hai già un account?',
    signupLink: 'Registrati',
    loginLink: 'Accedi',
    orContinueWith: 'O continua con',
    google: 'Google',
    resetTitle: 'Reimposta Password',
    resetDesc: 'Inserisci la tua email e ti invieremo un link per reimpostare la password.',
    resetBtn: 'Invia link',
    resetSuccess: 'Abbiamo inviato un link alla tua email.',
    backToLogin: 'Torna al login',
  },

  avisoLegalPage: {
    seoTitle: 'Avviso Legale | Punto Hispano',
    seoDesc: 'Informazioni legali complete su Punto Hispano e i suoi servizi.',
    title: 'Avviso Legale',
    subtitle: 'Informazioni legali complete su Punto Hispano e i nostri servizi',
    whatIs: 'Cos\'è questo avviso legale?',
    whatIsP1: 'Questo avviso legale regola l\'uso del sito web www.puntohispano.ch, di proprietà di Punto Hispano GmbH, società registrata in Svizzera.',
    whatIsP2: 'Navigando sul nostro sito web, accetti tutte le condizioni qui stabilite. Ti consigliamo di leggere attentamente queste informazioni.',
    whoWeAre: 'Chi siamo?',
    idData: 'Dati identificativi',
    company: 'Azienda',
    companySubtitle: 'Gestione & Consulenza in Svizzera',
    officialAddress: 'Indirizzo ufficiale',
    contactTitle: 'Come contattarci?',
    digitalComm: 'Comunicazione digitale',
    directComm: 'Comunicazione diretta',
    mainEmail: 'E-mail principale:',
    website: 'Sito web:',
    phone: 'Telefono:',
    officeHours: 'Orari di apertura:',
    weekdayHours: 'Lunedì a venerdì: 9:00 - 18:00',
    saturdayHours: 'Sabato: 10:00 - 14:00',
    termsTitle: 'Condizioni d\'uso del sito web',
    term1Title: '1. Accettazione delle condizioni',
    term1Desc: 'Accedendo e utilizzando questo sito web, accetti automaticamente di essere vincolato a queste condizioni d\'uso.',
    term2Title: '2. Uso consentito',
    term2Desc: 'Questo sito web è destinato esclusivamente a:',
    term2Items: ['Ottenere informazioni sui nostri servizi', 'Richiedere consulenze e preventivi', 'Contattare il nostro team professionale', 'Accedere a risorse e documentazione'],
    term3Title: '3. Uso vietato',
    term3Warning: 'È severamente vietato:',
    term3Items: ['Utilizzare il sito per attività illegali', 'Tentare di accedere ad aree riservate', 'Copiare o riprodurre contenuti senza autorizzazione', 'Inviare informazioni false o fuorvianti', 'Interferire con il funzionamento del sito'],
    ipTitle: 'Proprietà intellettuale e industriale',
    ipProtected: 'Cosa è protetto?',
    ipDesc: 'Tutti gli elementi di questo sito web sono protetti dalle leggi svizzere sulla proprietà intellettuale e industriale.',
    ipVisual: 'Elementi visivi',
    ipVisualItems: ['Design e layout', 'Loghi e marchi', 'Immagini e fotografie', 'Icone e grafiche'],
    ipTechnical: 'Elementi tecnici',
    ipTechnicalItems: ['Codice di programmazione', 'Database', 'Architettura web', 'Funzionalità'],
    ipWarning: 'La riproduzione, distribuzione o qualsiasi forma di sfruttamento dei contenuti senza autorizzazione è espressamente vietata.',
    responsibilityTitle: 'Responsabilità e limitazioni',
    ourCommitment: 'Il nostro impegno',
    ourCommitmentDesc: 'Punto Hispano si impegna a mantenere questo sito web operativo. Tuttavia, non possiamo garantire:',
    ourCommitmentItems: ['Disponibilità continua 24/7', 'Assenza totale di errori tecnici', 'Compatibilità con tutti i browser', 'Protezione assoluta contro attacchi informatici'],
    userResponsibility: 'Responsabilità dell\'utente',
    userResponsibilityDesc: 'Come utente del sito web, sei responsabile di:',
    userResponsibilityItems: ['Fornire informazioni veritiere e aggiornate', 'Mantenere la riservatezza delle tue credenziali', 'Utilizzare il sito in modo responsabile e legale', 'Rispettare i diritti di proprietà intellettuale'],
    lawTitle: 'Diritto applicabile e giurisdizione',
    applicableLaw: 'Diritto applicabile',
    applicableLawDesc: 'Questo avviso legale è regolato dal diritto svizzero, Cantone di Zurigo.',
    jurisdiction: 'Giurisdizione competente',
    jurisdictionDesc: 'Le parti si sottomettono alla giurisdizione dei tribunali di Zurigo, Svizzera.',
    faqTitle: 'Domande legali frequenti',
    faqMoreInfo: 'Hai bisogno di informazioni legali? Contatta i nostri esperti per una consulenza personalizzata',
    relatedPolicies: 'Politiche correlate',
    dataProtection: 'Protezione dei dati',
    dataProtectionDesc: 'Scopri come proteggiamo le tue informazioni personali',
    cookiePolicyLink: 'Politica dei cookie',
    cookiePolicyDesc: 'Informazioni sull\'uso dei cookie',
    privacyPolicyLink: 'Informativa sulla privacy',
    privacyPolicyDesc: 'Termini generali sulla privacy',
    legalQuestions: 'Domande legali?',
    legalQuestionsDesc: 'Non esitare a contattarci per qualsiasi domanda.',
    lastUpdated: 'Ultimo aggiornamento:',
    lastUpdatedDate: '24 giugno 2025',
  },
  politicaPrivacidadPage: {
    seoTitle: 'Informativa sulla Privacy | Protezione dei Dati | Punto Hispano',
    seoDesc: 'Informativa completa sulla privacy di Punto Hispano. Scopri come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali.',
    titlePart1: 'Informativa sulla',
    titlePart2: 'Privacy',
    subtitle: 'La tua privacy è fondamentale. Scopri come proteggiamo le tue informazioni con i più alti standard di sicurezza.',
    gdprBadge: 'Conforme al GDPR',
    encryptionBadge: 'Crittografia AES-256',
    isoBadge: 'ISO 27001',
    introTitle: 'Perché è importante la tua privacy?',
    introP1Pre: 'In',
    introP1Brand: 'Punto Hispano',
    introP1Post: ', valutiamo e rispettiamo la tua privacy come diritto fondamentale. Questa Informativa spiega in modo trasparente come raccogliamo, utilizziamo, condividiamo e proteggiamo le informazioni personali che ci fornisci.',
    introHighlight: 'Utilizzando i nostri servizi, accetti le pratiche descritte in questa Informativa.',
    introBadge1: 'Trasparenza Totale',
    introBadge2: 'Massima Sicurezza',
    introBadge3: 'Controllo Totale',
    whatTitle: 'Quali informazioni raccogliamo?',
    whatIntro: 'Raccogliamo diversi tipi di informazioni personali per offrirti i nostri servizi professionali al meglio.',
    section1Title: '1. Informazioni che ci fornisci',
    idCardTitle: 'Dati di identificazione',
    idCard1: 'Nome e cognome completi',
    idCard2: 'Documento d\'identità (CI, NIE, passaporto)',
    idCard3: 'Data di nascita e nazionalità',
    contactCardTitle: 'Informazioni di contatto',
    contactCard1: 'Indirizzo email',
    contactCard2: 'Numeri di telefono mobile e fisso',
    contactCard3: 'Indirizzo postale completo',
    profCardTitle: 'Dati professionali',
    profCard1: 'Azienda dove lavori e ruolo',
    profCard2: 'Settore di attività professionale',
    profCard3: 'Informazioni lavorative rilevanti',
    finCardTitle: 'Informazioni finanziarie',
    finCard1: 'Dati bancari (per elaborazione pagamenti)',
    finCard2: 'Informazioni fiscali necessarie',
    finCard3: 'Documentazione finanziaria per servizi specifici',
    section2Title: '2. Informazioni raccolte automaticamente',
    autoIntroLabel: 'Cosa raccogliamo?',
    autoIntroDesc: 'Quando visiti il nostro sito, raccogliamo automaticamente alcune informazioni tecniche.',
    autoUseLabel: 'Dati di utilizzo:',
    autoUseDesc: 'pagine visitate, tempo trascorso, link utilizzati',
    autoDeviceLabel: 'Informazioni del dispositivo:',
    autoDeviceDesc: 'tipo di dispositivo, sistema operativo, browser',
    autoLocLabel: 'Informazioni di localizzazione:',
    autoLocDesc: 'paese e regione (in base al tuo IP)',
    autoCookiesLabel: 'Cookie:',
    autoCookiesDesc: 'per maggiori informazioni, consulta la nostra Politica dei Cookie',
    useTitle: 'Come utilizziamo le tue informazioni?',
    useIntro: 'Utilizziamo i tuoi dati personali esclusivamente per i seguenti scopi legittimi:',
    useServicesTitle: 'Servizi principali',
    useService1: 'Fornire e mantenere i nostri servizi',
    useService2: 'Elaborare transazioni e pagamenti',
    useService3: 'Gestire il tuo account e profilo',
    useService4: 'Adempiere obblighi contrattuali',
    useCommTitle: 'Comunicazione',
    useComm1: 'Rispondere a richieste',
    useComm2: 'Inviare aggiornamenti dei servizi',
    useComm3: 'Fornire supporto tecnico',
    useComm4: 'Comunicare informazioni importanti',
    useImproveTitle: 'Miglioramento e analisi',
    useImprove1: 'Personalizzare la tua esperienza',
    useImprove2: 'Analizzare tendenze e utilizzo',
    useImprove3: 'Migliorare i nostri servizi',
    useImprove4: 'Sviluppare nuove funzionalità',
    useSecTitle: 'Sicurezza e legale',
    useSec1: 'Rilevare attività fraudolente',
    useSec2: 'Adempiere obblighi legali',
    useSec3: 'Proteggere diritti e sicurezza',
    useSec4: 'Risolvere controversie legali',
    legalTitle: 'Base legale per il trattamento',
    legalIntro: 'Trattiamo i tuoi dati personali sulle seguenti basi legali riconosciute:',
    legal1Title: 'Esecuzione di un contratto',
    legal1Desc: 'Quando il trattamento è necessario per adempiere ai nostri obblighi contrattuali.',
    legal2Title: 'Consenso',
    legal2Desc: 'Quando hai dato il consenso esplicito al trattamento per uno scopo specifico.',
    legal3Title: 'Interessi legittimi',
    legal3Desc: 'Quando il trattamento è necessario per i nostri interessi legittimi, salvo che prevalgano i tuoi diritti fondamentali.',
    legal4Title: 'Obbligo legale',
    legal4Desc: 'Quando il trattamento è necessario per adempiere un obbligo legale applicabile.',
    shareTitle: 'Con chi condividiamo le tue informazioni?',
    shareImportant: 'IMPORTANTE: Non vendiamo i tuoi dati personali a terzi',
    shareIntro: 'Possiamo condividere i tuoi dati solo con le seguenti categorie di destinatari:',
    share1Title: 'Fornitori di servizi',
    share1Desc: 'Aziende che forniscono servizi per nostro conto (pagamenti, analisi, hosting, supporto) sotto rigorosi accordi di riservatezza.',
    share2Title: 'Partner commerciali',
    share2Desc: 'Terzi con cui collaboriamo per servizi specifici o promozioni congiunte, sempre con il tuo consenso preventivo.',
    share3Title: 'Autorità competenti',
    share3Desc: 'Quando necessario per adempiere un obbligo legale, una decisione giudiziaria o una richiesta amministrativa valida.',
    share4Title: 'Transazioni aziendali',
    share4Desc: 'Nel contesto di una transazione (fusione, acquisizione, vendita), proteggendo sempre i tuoi diritti.',
    intlTitle: 'Trasferimenti internazionali di dati',
    intlIntro: 'I tuoi dati possono essere trasferiti in paesi con leggi sulla protezione diverse.',
    intlGuaranteeLabel: 'Garanzie di protezione:',
    intlGuaranteeDesc: 'Per i trasferimenti fuori dal SEE o dalla Svizzera, garantiamo adeguate tutele come le clausole contrattuali standard approvate dalla Commissione Europea.',
    secTitle: 'Come proteggiamo le tue informazioni?',
    secIntro: 'Implementiamo misure di sicurezza tecniche, amministrative e fisiche per proteggere i tuoi dati.',
    secTechTitle: 'Misure tecniche',
    secTech1: 'Crittografia AES-256 per archiviazione',
    secTech2: 'Comunicazioni SSL/TLS sicure',
    secTech3: 'Sistemi di rilevamento intrusioni',
    secTech4: 'Backup crittografati',
    secAdminTitle: 'Misure amministrative',
    secAdmin1: 'Accesso limitato al personale autorizzato',
    secAdmin2: 'Formazione regolare sulla protezione dati',
    secAdmin3: 'Politiche interne di sicurezza',
    secAdmin4: 'Audit di sicurezza periodici',
    secLimitsLabel: 'Limitazioni:',
    secLimitsDesc: 'Nonostante le migliori misure, nessun sistema è completamente inviolabile. Non possiamo garantire sicurezza assoluta.',
    retentionTitle: 'Per quanto tempo conserviamo i tuoi dati?',
    retentionIntro: 'Conserviamo i tuoi dati solo per il tempo necessario, salvo obblighi legali più lunghi.',
    ret1Title: 'Documenti contrattuali',
    ret1Desc: 'Durata del contratto + 6 anni',
    ret2Title: 'Documenti fiscali',
    ret2Desc: '10 anni (legge svizzera)',
    ret3Title: 'Comunicazioni',
    ret3Desc: '3 anni dall\'ultima interazione',
    ret4Title: 'Dati di navigazione',
    ret4Desc: 'Massimo 2 anni',
    rightsTitle: 'Quali sono i tuoi diritti?',
    rightsIntro: 'A seconda del tuo paese di residenza, hai diritti importanti sui tuoi dati personali:',
    rightAccessTitle: 'Diritto di accesso',
    rightAccessDesc: 'Puoi richiedere informazioni sui dati che possediamo su di te.',
    rightRectifyTitle: 'Diritto di rettifica',
    rightRectifyDesc: 'Puoi chiedere la correzione di dati inesatti o incompleti.',
    rightDeleteTitle: 'Diritto alla cancellazione',
    rightDeleteDesc: 'Puoi chiedere la cancellazione dei tuoi dati personali.',
    rightPortTitle: 'Diritto alla portabilità',
    rightPortDesc: 'Puoi ricevere i tuoi dati in formato strutturato e trasferirli.',
    rightOpposeTitle: 'Diritto di opposizione',
    rightOpposeDesc: 'Puoi opporti al trattamento in determinate circostanze.',
    rightWithdrawTitle: 'Revoca del consenso',
    rightWithdrawDesc: 'Puoi revocare il consenso in qualsiasi momento.',
    rightsHowLabel: 'Come esercitare i tuoi diritti?',
    rightsHowDesc: 'Per esercitare questi diritti, contattaci tramite le informazioni nella sezione "Contatto".',
    faqTitle: 'Domande frequenti sulla privacy',
    faqSubtitle: 'Risposte chiare alle tue domande più comuni.',
    faq1Q: 'Quali dati personali raccoglie Punto Hispano?',
    faq1A: 'Raccogliamo dati di identificazione, contatto, professionali e finanziari necessari per i nostri servizi, solo con il tuo consenso.',
    faq2Q: 'Come protegge Punto Hispano i miei dati?',
    faq2A: 'Implementiamo misure di sicurezza tecniche e amministrative avanzate, inclusa la crittografia AES-256 e accesso limitato al personale autorizzato.',
    faq3Q: 'Posso richiedere la cancellazione dei miei dati?',
    faq3A: 'Sì, hai il diritto di richiedere la cancellazione dei tuoi dati quando non sono più necessari, nel rispetto degli obblighi legali.',
    faq4Q: 'Punto Hispano condivide i miei dati con terzi?',
    faq4A: 'Non vendiamo i tuoi dati. Li condividiamo solo con fornitori fidati, per obblighi legali o con il tuo consenso esplicito.',
    changesTitle: 'Modifiche a questa Informativa',
    changesP1: 'Possiamo aggiornare periodicamente questa Informativa per riflettere modifiche delle pratiche o normative.',
    changesNotifyLabel: 'Ti notificheremo:',
    changesNotifyDesc: 'Qualsiasi modifica importante sarà comunicata pubblicando la nuova Informativa e aggiornando la data.',
    contactTitle: 'Hai domande sulla privacy?',
    contactIntro: 'Per qualsiasi domanda o preoccupazione su questa Informativa o sul trattamento dei tuoi dati, contattaci:',
    contactCompanyLabel: 'Azienda:',
    contactCompanyValue: 'Punto Hispano',
    contactAddressLabel: 'Indirizzo:',
    contactEmailLabel: 'Email:',
    contactPhoneLabel: 'Telefono:',
    lastUpdated: 'Ultimo aggiornamento:',
    lastUpdatedDate: '24 giugno 2025',
    lastUpdateNote: 'Questa politica può essere modificata per riflettere cambiamenti di pratiche o normative',
  },
  politicaCookiesPage: {
    seoTitle: 'Politica dei Cookie | Punto Hispano',
    seoDesc: 'Informazioni sui cookie che utilizziamo e come gestire le tue preferenze.',
    title: 'Politica dei Cookie',
    subtitle: 'Trasparenza totale su come utilizziamo i cookie sul nostro sito web',
    whatAreCookies: 'Cosa sono i cookie e perché li utilizziamo?',
    whatAreCookiesP1: 'I cookie sono piccoli file di testo salvati sul tuo dispositivo quando visiti il nostro sito web. Sono completamente sicuri e ci aiutano a offrirti una migliore esperienza.',
    whatAreCookiesP2: 'In Punto Hispano utilizziamo i cookie in modo responsabile e trasparente, in conformità con la normativa europea.',
    cookieTypes: 'Quali tipi di cookie utilizziamo?',
    essentialTitle: 'Cookie essenziali o necessari',
    essentialWhat: 'Cosa fanno?',
    essentialWhatDesc: 'Sono indispensabili per il corretto funzionamento del nostro sito web.',
    essentialWhy: 'Perché ne abbiamo bisogno?',
    essentialWhyDesc: 'Permettono la navigazione, l\'accesso ad aree sicure e le funzionalità di base.',
    essentialNote: 'Questi cookie non richiedono il tuo consenso poiché sono tecnicamente necessari.',
    preferencesTitle: 'Cookie di preferenza',
    preferencesWhatDesc: 'Ricordano le tue preferenze per personalizzare la tua esperienza.',
    preferencesExamples: 'Lingua selezionata, impostazioni di accessibilità, preferenze di navigazione.',
    preferencesNote: 'Migliorano la tua esperienza ma non sono indispensabili.',
    analyticsTitle: 'Cookie statistici o analitici',
    analyticsWhatDesc: 'Ci aiutano a capire come utilizzi il nostro sito web in modo anonimo.',
    analyticsWhyDesc: 'Miglioriamo costantemente i nostri servizi basandoci su dati reali.',
    analyticsNote: 'I dati vengono elaborati in modo anonimo e aggregato.',
    marketingTitle: 'Cookie di marketing',
    marketingWhatDesc: 'Ci permettono di mostrarti contenuti e offerte più pertinenti.',
    marketingHowDesc: 'Tracciano il tuo comportamento di navigazione per personalizzare l\'esperienza.',
    marketingNote: 'Puoi sempre disattivare questi cookie senza influire sul funzionamento del sito.',
    specificCookies: 'Cookie specifici che utilizziamo',
    tableName: 'Nome',
    tableProvider: 'Fornitore',
    tablePurpose: 'Scopo',
    tableDuration: 'Durata',
    tableType: 'Tipo',
    controlTitle: 'Come controllare i cookie?',
    controlDesc: 'Hai il pieno controllo. Puoi accettarli, rifiutarli o configurarli secondo le tue preferenze.',
    onOurSite: 'Sul nostro sito web',
    onOurSiteDesc: 'Alla prima visita, appare un banner dove puoi:',
    onOurSiteItems: ['Accettare tutti i cookie', 'Rifiutare quelli non essenziali', 'Configurare le tue preferenze in dettaglio'],
    inBrowser: 'Nel tuo browser',
    inBrowserDesc: 'Puoi anche gestire i cookie direttamente dal tuo browser:',
    inBrowserItems: ['Bloccare tutti i cookie', 'Eliminare i cookie esistenti', 'Configurare eccezioni per sito web'],
    browserSettings: 'Impostazioni del browser',
    thirdPartyCookies: 'Cookie di terze parti',
    thirdPartyWarning: 'Alcuni servizi esterni (come Google Analytics) possono installare i propri cookie.',
    thirdPartyDesc: 'Ci assicuriamo che:',
    thirdPartyItems: ['Lavoriamo solo con fornitori che rispettano la privacy', 'I dati vengono elaborati in modo anonimo', 'Siano conformi alla normativa europea', 'Puoi disattivarli se lo desideri'],
    changesTitle: 'Modifiche alla nostra Politica dei Cookie',
    changesDesc: 'Potremmo aggiornare questa politica occasionalmente.',
    changesNotice: 'Qualsiasi cambiamento importante sarà comunicato chiaramente sul nostro sito web.',
    questionsTitle: 'Domande sui cookie?',
    questionsDesc: 'Non esitare a contattarci:',
    lastUpdated: 'Ultimo aggiornamento:',
    lastUpdatedDate: '24 giugno 2025',
  },
  politicaGdprPage: {
    seoTitle: 'Politica GDPR | Protezione dei Dati Personali | Punto Hispano',
    seoDesc: 'Politica di protezione dei dati personali secondo il GDPR. Conosci i tuoi diritti e come trattiamo le tue informazioni.',
    title: 'Protezione dei Dati Personali',
    subtitle: 'La tua privacy è la nostra priorità — Conosci i tuoi diritti secondo il GDPR',
    whyImportant: 'Perché è importante la tua privacy?',
    whyImportantP1: 'In Punto Hispano trattiamo le tue informazioni personali con il massimo rispetto e trasparenza. Rispettiamo il GDPR e la Legge federale svizzera sulla protezione dei dati.',
    whyImportantP2: 'Questa politica ti spiega in modo semplice quali dati raccogliamo, come li utilizziamo e quali sono i tuoi diritti.',
    whoResponsible: 'Chi è responsabile dei tuoi dati?',
    whoResponsibleDesc: 'Punto Hispano Holding è l\'azienda responsabile del trattamento dei tuoi dati personali.',
    ourAddress: 'Il nostro indirizzo:',
    phoneLabel: 'Telefono:',
    emailGeneralLabel: 'Email generale:',
    whatData: 'Quali informazioni raccogliamo?',
    whatDataIntro: 'Raccogliamo solo le informazioni necessarie per offrirti i nostri servizi professionali. La quantità e il tipo dipendono dal servizio richiesto.',
    data1Title: '1. Dati di identificazione di base',
    data1What: 'Cosa include:',
    data1WhatDesc: 'Nome completo, documento d\'identità, data di nascita, nazionalità.',
    data1Why: 'Perché ne abbiamo bisogno:',
    data1WhyDesc: 'Essenziali per fornire servizi legali e amministrativi in Svizzera.',
    data2Title: '2. Informazioni di contatto',
    data2WhatDesc: 'Indirizzo postale, telefoni, email, contatto di emergenza.',
    data2WhyDesc: 'Per comunicare con te e inviarti documenti importanti.',
    data3Title: '3. Dati professionali e finanziari',
    data3WhatDesc: 'Situazione lavorativa, azienda, redditi, documenti fiscali.',
    data3WhyDesc: 'Per pratiche amministrative, fiscali e assicurative.',
    data4Title: '4. Dati speciali (solo con il tuo permesso)',
    data4Important: 'Importante:',
    data4ImportantDesc: 'Trattiamo i dati sensibili solo con il tuo consenso esplicito.',
    data4WhatDesc: 'Stato civile, dati sanitari (per assicurazione medica), informazioni bancarie.',
    data4Control: 'Il tuo controllo:',
    data4ControlDesc: 'Puoi revocare questo consenso in qualsiasi momento.',
    rightsTitle: 'Quali sono i tuoi diritti?',
    rightsIntro: 'Come titolare di dati personali, hai diritti importanti che puoi esercitare in qualsiasi momento:',
    right1Title: 'Diritto di sapere',
    right1Desc: 'Puoi richiedere informazioni sui dati che possediamo, su come li usiamo e con chi li condividiamo.',
    right2Title: 'Diritto di rettifica',
    right2Desc: 'In caso di dati errati o incompleti, puoi richiedere la correzione immediata.',
    right3Title: 'Diritto all\'oblio',
    right3Desc: 'Puoi richiedere la cancellazione dei tuoi dati quando non sono più necessari (rispettando gli obblighi di legge).',
    right4Title: 'Diritto alla portabilità',
    right4Desc: 'Puoi ricevere i tuoi dati in formato digitale per trasferirli a un altro fornitore.',
    howExercise: 'Come esercitare i tuoi diritti?',
    howExerciseIntro: 'È molto semplice. Puoi contattarci tramite uno di questi canali:',
    byEmail: 'Via email',
    byEmailWrite: 'Scrivi a:',
    byEmailNote: 'Allega copia del documento d\'identità',
    byPhone: 'Per telefono',
    byPhoneCall: 'Chiama:',
    byPhoneNote: 'Orari d\'ufficio',
    inPerson: 'Di persona',
    inPersonVisit: 'Visita i nostri uffici',
    inPersonNote: 'Richiedi un appuntamento',
    responseTime: 'Tempo di risposta:',
    responseTimeDesc: 'Rispondiamo entro un massimo di 30 giorni. Per casi complessi possono servire fino a 60 giorni, ma ti avviseremo.',
    howProtect: 'Come proteggiamo le tue informazioni?',
    securityMeasures: 'Misure di sicurezza',
    securityIntro: 'Adottiamo le migliori misure tecniche per proteggere i tuoi dati:',
    security1: 'Crittografia AES-256 per l\'archiviazione',
    security2: 'Comunicazioni sicure SSL/TLS',
    security3: 'Accesso ristretto al solo personale autorizzato',
    security4: 'Backup crittografati',
    security5: 'Formazione regolare del team sulla protezione dati',
    retention: 'Per quanto tempo conserviamo i tuoi dati?',
    retentionIntro: 'Conserviamo le tue informazioni solo per il tempo necessario:',
    retention1Label: 'Documenti fiscali:',
    retention1Desc: '10 anni (legge svizzera)',
    retention2Label: 'Marketing:',
    retention2Desc: 'Fino alla revoca del consenso',
    retention3Label: 'Comunicazioni:',
    retention3Desc: '3 anni dall\'ultima interazione',
    retention4Label: 'Dati web:',
    retention4Desc: 'Massimo 2 anni',
    international: 'Trasferimenti internazionali',
    internationalDesc: 'Se dobbiamo trasferire dati fuori dall\'Europa, lo facciamo solo verso paesi con protezione adeguata (come la Spagna) o fornitori certificati negli USA.',
    questionsTitle: 'Hai domande o reclami?',
    questionsIntro: 'Per domande su questa politica o su come trattiamo i tuoi dati, contatta il nostro Responsabile della Protezione dei Dati:',
    emailLabel: 'Email:',
    complaintLabel: 'Diritto di reclamo:',
    complaintDesc: 'Se ritieni che non rispettiamo la normativa, puoi presentare reclamo all\'Autorità federale svizzera per la protezione dei dati (IFPDT) o all\'autorità del tuo paese di residenza.',
    lastUpdated: 'Ultimo aggiornamento:',
    lastUpdatedDate: '24 giugno 2025',
    updateNote: 'Ti notificheremo qualsiasi modifica importante di questa politica',
  },
  heroHome: {
    titleLine1: 'Smetti di sopravvivere.',
    titleLine2: 'Inizia a vivere in Svizzera.',
    subtitle: 'Sappiamo cosa significa essere persi con la burocrazia. Recupera la tua tranquillità: ci occupiamo di tutto noi.',
    cta: 'Scopri le nostre soluzioni',
    statFamilies: 'Famiglie serene',
    statFamiliesDesc: 'Hanno risolto le loro pratiche',
    statYears: 'Anni di esperienza',
    statYearsDesc: 'Problemi reali come il tuo',
    statAvailable: 'Sempre disponibili',
    statAvailableDesc: 'Quando hai bisogno di noi, siamo qui',
    statSolutions: 'Soluzioni',
    statSolutionsDesc: 'Per ogni problema che affronti',
  },
  footerLinks: {
    servicios: 'Servizi', gestoria: 'Gestione', lifestyle: 'Lifestyle', empresa: 'Azienda', legal: 'Legale',
    gestoriaAdmin: 'Gestione & Amministrazione', asesoriaLegal: 'Consulenza Legale', formacionIdiomas: 'Formazione Linguistica', segurosPensiones: 'Assicurazioni & Previdenza',
    desempleoRav: 'Disoccupazione (URC)', administracion: 'Amministrazione', cvDoc: 'CV & Documenti', acompanamientos: 'Accompagnamenti', traducciones: 'Traduzioni', paquetes: 'Pacchetti Speciali',
    vehiculos: 'Noleggio Veicoli', viviendas: 'Affitto Alloggi', packRelocation: 'Pack Relocation', solucionesDigitales: 'Soluzioni Digitali',
    sobreNosotros: 'Chi Siamo', blog: 'Blog', contacto: 'Contatto', zonasServicio: 'Zone di Servizio',
    privacidad: 'Privacy Policy', avisoLegal: 'Avviso Legale', cookies: 'Cookie Policy', gdpr: 'GDPR',
    invalidEmail: 'E-mail non valida', errorRetry: 'Errore. Riprova.', followUs: 'Seguici su',
  },
  navbar: {
    tagline: 'La tua gestione & consulenza in', contactUs: 'Contattaci', closeMenu: 'Chiudi menu', openMenu: 'Apri menu',
    myProfile: 'Il mio Profilo', logout: 'Esci', login: 'Accedi',
  },
  cart: {
    title: 'Il tuo Carrello', emptyCart: 'Il tuo carrello è vuoto', service: 'servizio', services: 'servizi', selected: 'selezionati', clearCart: 'Svuota carrello',
    limitedOffer: 'Offerta Limitata!', addMoreServices: 'Aggiungi più servizi e ottieni sconti esclusivi',
    numberOfPeople: 'Numero di persone:', couponPlaceholder: 'Codice coupon', apply: 'Applica',
    subtotal: 'Subtotale:', persons: 'persone:', discount: 'Sconto:', total: 'Totale:', continue: 'Continua', backToCart: '← Torna al carrello',
    couponInvalid: 'Coupon non valido o scaduto', couponExpired: 'Questo coupon è scaduto', couponMaxUses: 'Questo coupon ha raggiunto il limite di utilizzo',
    couponMinPurchase: 'Acquisto minimo di {amount} CHF richiesto', couponApplied: 'Coupon applicato!', couponDiscount: 'Sconto di {discount}',
    couponRemoved: 'Coupon rimosso', couponRemovedDesc: 'Lo sconto è stato rimosso', couponError: 'Errore nella validazione del coupon',
    serviceRemoved: 'Servizio rimosso', serviceRemovedDesc: '"{title}" è stato rimosso dal carrello',
    paymentMigration: 'Pagamenti in migrazione', paymentMigrationDesc: 'Stiamo migrando questo checkout. Contattaci per finalizzare la tua richiesta.',
    paymentError: 'Impossibile continuare', paymentErrorDesc: 'Riprova tra un momento',
  },
  contactForm: {
    fullName: 'Nome completo', email: 'E-mail', phone: 'Telefono', serviceArea: 'Area di servizio', selectService: 'Seleziona un servizio',
    message: 'Messaggio', messagePlaceholder: 'Descrivi la tua richiesta o progetto...', characters: 'caratteri',
    send: 'Invia messaggio', sending: 'Invio in corso...', formErrors: 'Errori nel modulo:', formErrorsDesc: 'Si prega di correggere gli errori indicati.',
    tooManyAttempts: 'Troppi tentativi. Riprova tra {seconds} secondi.', submitError: 'Errore nell\'invio. Riprova.',
    successTitle: 'Messaggio inviato', successDesc: 'Grazie per averci contattato. Risponderemo presto.',
    errorTitle: 'Errore', errorDesc: 'Si è verificato un errore nell\'invio del messaggio.',
    gestoriaOption: 'Gestione & Amministrazione', legalOption: 'Consulenza Legale', segurosOption: 'Assicurazioni & Previdenza',
    idiomasOption: 'Corsi di Lingua', digitalOption: 'Servizi Digitali', webOption: 'Web Design', crmOption: 'CRM',
    iaOption: 'Intelligenza Artificiale', automationOption: 'Automazione', devOption: 'Sviluppo Personalizzato', generalOption: 'Richiesta Generale',
    namePlaceholder: 'Il tuo nome completo',
  },
  categoryHero: { requestInfo: 'Richiedi informazioni', meetTeam: 'Conosci il nostro team' },
  gestoriaCategoryPage: {
    specializedAgency: 'Gestione Specializzata', professionalService: 'Servizio professionale in spagnolo per ispanofoni in Svizzera.',
    freeConsultation: 'Consulenza Gratuita', callNow: 'Chiama Ora',
    clientsServed: 'Clienti serviti', fastResponse: 'Risposta rapida', inSpanish: 'In spagnolo', averageRating: 'Valutazione media',
    servicesOf: 'Servizi di', finalPrices: 'Tutti i prezzi sono definitivi. Nessun costo nascosto.', popular: 'Popolare', add: 'Aggiungi', consult: 'Consulta',
    freeOrConsult: 'Gratuito o da consultare', freeOrConsultDesc: 'Contattaci per maggiori informazioni.',
    addedToCart: 'Aggiunto al carrello',
    howItWorks: 'Come funziona?', step1: 'Contatto', step1Desc: 'Raccontaci la tua situazione via WhatsApp o telefono',
    step2: 'Documentazione', step2Desc: 'Raccogliamo tutta la documentazione necessaria', step3: 'Gestione', step3Desc: 'Eseguiamo tutte le pratiche per te',
    step4: 'Risultato', step4Desc: 'Ti consegniamo tutto completato e spiegato',
    needHelp: 'Hai bisogno di aiuto con', firstFree: 'Prima consulenza gratuita. Senza impegno.', whatsapp: 'WhatsApp',
  },
  categoryFaq: { defaultTitle: 'Domande frequenti' },
  categoryBlog: { defaultTitle: 'Articoli correlati', viewAll: 'Vedi tutti gli articoli', readMore: 'Leggi di più' },
  categoryContact: {
    defaultTitle: 'Contatta i nostri esperti', defaultDesc: 'Richiedi informazioni o un preventivo personalizzato',
    preferDirect: 'Preferisci parlare direttamente?', teamAvailable: 'Il nostro team è disponibile per rispondere a tutte le tue domande via WhatsApp o programmare una chiamata.',
    formSent: 'Modulo inviato!', formSentDesc: 'Grazie per averci contattato. Un membro del team ti risponderà il prima possibile.',
    sendAnother: 'Invia un altro messaggio', name: 'Nome', namePlaceholder: 'Il tuo nome completo', email: 'E-mail',
    phoneOptional: 'Telefono (opzionale)', serviceArea: 'Area di servizio', selectService: 'Seleziona un servizio',
    message: 'Messaggio', messagePlaceholder: 'Descrivi la tua richiesta in dettaglio', sending: 'Invio in corso...', send: 'Invia messaggio',
    successTitle: 'Modulo inviato con successo', successDesc: 'Ti contatteremo il prima possibile',
  },
  writeReview: {
    title: 'Scrivi una recensione', whereToWrite: 'Dove vorresti scrivere la tua recensione?',
    googleReview: 'Recensione Google', googleDesc: 'Pubblica, appare su Google Maps',
    websiteReview: 'Recensione sul nostro sito', websiteDesc: 'Appare sul nostro sito dopo la verifica',
    recommendGoogle: 'Raccomandiamo anche di scrivere su Google per massima visibilità',
    redirectGoogle: 'Ti reindirizzeremo a Google', redirectGoogleDesc: 'Sarai portato su Google Maps.',
    goToGoogle: 'Vai su Google Maps', goBack: 'Indietro',
    nameLabel: 'Nome *', emailLabel: 'E-mail *', ratingLabel: 'Valutazione *', starsOf: 'su 5 stelle',
    serviceUsed: 'Servizio utilizzato', selectServicePlaceholder: 'Seleziona il servizio',
    reviewTitle: 'Titolo della recensione', reviewTitlePlaceholder: 'Riepilogo della tua esperienza',
    yourReview: 'La tua recensione *', yourReviewPlaceholder: 'Raccontaci la tua esperienza con i nostri servizi...',
    submitReview: 'Invia recensione', submitting: 'Invio in corso...',
    reviewNote: '* La tua recensione sarà verificata prima della pubblicazione.',
    requiredFields: 'Campi obbligatori', requiredFieldsDesc: 'Si prega di compilare tutti i campi obbligatori.',
    reviewSent: 'Recensione inviata!', reviewSentDesc: 'La tua recensione sarà verificata. Grazie per il tuo feedback!',
    reviewError: 'Impossibile inviare la recensione. Riprova.',
    gestoria: 'Gestione', legal: 'Consulenza Legale', seguros: 'Assicurazioni', idiomas: 'Formazione Linguistica',
    web: 'Sviluppo Web', crm: 'CRM & Automazione', general: 'Richiesta Generale',
  },
  blogNewsletter: {
    welcomeTitle: 'Benvenuto nella nostra comunità!', welcomeDesc: 'Riceverai i nostri migliori contenuti e consigli esclusivi',
    title: 'Newsletter Esclusiva per Ispanofoni', subtitle: 'Ricevi settimanalmente guide pratiche e consigli legali',
    exclusive: 'Contenuto Esclusivo', exclusiveDesc: 'Guide non disponibili sul blog',
    legalUpdates: 'Aggiornamenti Legali', legalUpdatesDesc: 'Cambiamenti fiscali e legali in Svizzera',
    weeklyTips: 'Consigli Settimanali', weeklyTipsDesc: 'Consigli pratici ogni settimana',
    namePlaceholder: 'Il tuo nome (opzionale)', subscribing: 'Iscrizione...', subscribe: 'Iscriviti Gratis',
    noSpam: 'Niente spam. Puoi cancellarti in qualsiasi momento.',
    invalidEmail: 'E-mail non valida', invalidEmailDesc: 'Inserisci un\'e-mail valida',
    successTitle: 'Iscrizione riuscita!', successDesc: 'Ti abbiamo inviato un\'e-mail di conferma',
    errorTitle: 'Errore', errorDesc: 'Problema con l\'iscrizione. Riprova.',
  },
  exitIntent: {
    defaultTitle: 'Aspetta! Abbiamo qualcosa per te', defaultDesc: 'Prima di andare, lasciaci la tua e-mail e ricevi una consulenza gratuita di 10 minuti',
    defaultOffer: 'Consulenza gratuita', submit: 'Voglio la mia consulenza gratuita',
    sending: 'Invio in corso...', thanks: 'Grazie! Ti contatteremo presto',
    error: 'Errore nell\'invio. Riprova', dismiss: 'No grazie, continua a navigare',
  },
  contactInline: {
    nameFull: 'Nome completo', namePlaceholder: 'Il tuo nome', email: 'E-mail',
    phoneOptional: 'Telefono (opzionale)', serviceInterest: 'Servizio di interesse',
    selectService: 'Seleziona un servizio', gestoria: 'Gestione & Amministrazione', legal: 'Consulenza Legale',
    idiomas: 'Formazione Linguistica', seguros: 'Assicurazioni & Previdenza', digital: 'Soluzioni Digitali',
    coches: 'Noleggio Auto', viviendas: 'Affitto Alloggi', relocation: 'Pack Relocation',
    orientacion: 'Non sono sicuro/a — ho bisogno di orientamento',
    whatWorries: 'Cosa ti preoccupa?', tellUs: 'Raccontaci brevemente la tua situazione...',
    sending: 'Invio in corso...', sendFree: 'Invia la mia Richiesta Gratuita',
    dataPrivacy: '🔒 I tuoi dati sono riservati. Non condividiamo le tue informazioni.',
    sentTitle: 'Messaggio Inviato!', sentDesc: 'Rispondiamo entro 2 ore in orario lavorativo.',
    sendAnother: 'Invia un altro messaggio', successTitle: 'Messaggio inviato!', successDesc: 'Rispondiamo entro 2 ore.',
    errorTitle: 'Errore nell\'invio', errorDesc: 'Si è verificato un problema. Riprova.',
  },
  homeFeatured: {
    kicker: 'Servizi in evidenza', deliveredThisYear: 'servizi forniti quest\'anno',
    title: 'Servizi professionali in Svizzera per ispanofoni',
    subtitle: 'Gestione, consulenza legale e trasformazione digitale, tutto nella tua lingua',
    desc: 'Ottimizza le tasse, regolarizza la tua situazione e fai crescere la tua attività',
    viewAll: 'Vedi Tutti i Servizi',
    gestoria: 'Gestione Fiscale', gestoriaDesc: 'Consulenza fiscale personalizzata per privati e aziende.',
    gestoriaBtn: 'Vedi servizi di gestione',
    legal: 'Consulenza Legale', legalDesc: 'Servizio legale specializzato per la comunità ispanofona.',
    legalBtn: 'Vedi servizi legali',
    digital: 'Soluzioni Digitali', digitalDesc: 'Trasformazione digitale per far crescere la tua attività.',
    digitalBtn: 'Vedi soluzioni digitali',
    feat1: 'Dichiarazioni dei redditi', feat2: 'Pianificazione fiscale', feat3: 'Contabilità', feat4: 'Ottimizzazione fiscale',
    feat5: 'Immigrazione & residenza', feat6: 'Contratti di lavoro', feat7: 'Diritto di famiglia', feat8: 'Consulenza immobiliare',
    feat9: 'Web design professionale', feat10: 'Sistemi CRM personalizzati', feat11: 'Automazione processi', feat12: 'Marketing digitale efficace',
  },
  homeStats: {
    title: 'Risultati che ispirano fiducia', updated: 'Aggiornato 2025',
    clients: 'Clienti Soddisfatti', clientsDesc: 'Si sono affidati a noi',
    procedures: 'Pratiche Completate', proceduresDesc: 'Risoluzione riuscita',
    companies: 'Aziende Create', companiesDesc: 'In tutta la Svizzera',
    experience: 'Anni di Esperienza', experienceDesc: 'Servizio continuativo',
  },
  homeTestimonials: {
    title: 'Cosa Dicono i Nostri Clienti', subtitle: 'Recensioni reali di clienti soddisfatti',
    basedOn: 'Basato su 50+ recensioni Google', verified: 'Verificato', googleReview: 'Recensione Google',
    viewAll: 'Vedi tutte le recensioni', leaveReview: 'Lasciaci una recensione',
    usedServices: 'Hai utilizzato i nostri servizi? La tua opinione è molto importante per noi.',
  },
  serviciosSection: {
    title: 'Servizi', titleAccent: 'chiave per la tua vita in Svizzera',
    subtitle: 'Tutto in un unico posto, senza barriere linguistiche.',
    gestoria: 'Gestione & Amministrazione', gestoriaDesc: 'Tasse e contabilità senza complicazioni.',
    legal: 'Consulenza Legale', legalDesc: 'Immigrazione, lavoro e famiglia con avvocati bilingui.',
    idiomas: 'Corsi di Tedesco', idiomasDesc: 'Progressi dalla prima settimana.',
    seguros: 'Assicurazioni & 3° Pilastro', segurosDesc: 'Confronto indipendente. Risparmi reali.',
    digital: 'Soluzioni Digitali', digitalDesc: 'Web + CRM + IA per crescere in Svizzera.',
    coches: 'Noleggio Auto', cochesDesc: 'Consegna flessibile, tutto rischio, in spagnolo.',
    viviendas: 'Affitto Alloggi', viviendasDesc: 'Organizziamo visite e contratto, tu scegli.',
    relocation: 'Pack Relocation', relocationDesc: 'Arrivi e noi risolviamo tutto in 30 giorni.',
    bestSeller: 'Più venduto 🔥', forHispanics: 'Per ispanofoni', save25: 'Risparmia fino al 25%', allInclusive: 'Tutto incluso ✅',
    learnMore: 'Scopri di più', customSolution: 'Hai bisogno di una soluzione personalizzata?',
    customDesc: 'Contatta i nostri esperti per una consulenza gratuita.',
    enterBtn: 'Accedi', creating: 'Creazione account...', createBtn: 'Crea account',
    trustClients: 'Clienti soddisfatti', trustResponse: 'Tempo di risposta', trustResponseValue: '< 2 ore',
    trustLanguages: 'Lingue', trustLanguagesValue: 'ES, DE, EN',
  },
  resetPassword: {
    seoTitle: 'Nuova Password - Punto Hispano', seoDesc: 'Imposta la tua nuova password',
    successSeoTitle: 'Password Aggiornata', successSeoDesc: 'La tua password è stata aggiornata',
    invalidLink: 'Link non valido o scaduto', invalidLinkDesc: 'Richiedi un nuovo link',
    passwordMin: 'La password deve avere almeno 8 caratteri',
    mismatch: 'Le password non corrispondono', mismatchDesc: 'Verifica che entrambe le password siano uguali',
    tooShort: 'Password troppo corta', tooShortDesc: 'Minimo 8 caratteri',
    successTitle: 'Password aggiornata!', successDesc: 'La tua password è stata cambiata con successo',
    successRedirect: 'Password cambiata con successo. Sarai reindirizzato automaticamente...',
    goToClient: 'Vai all\'area cliente', newPassword: 'Nuova Password', enterNew: 'Inserisci la tua nuova password',
    newPasswordLabel: 'Nuova password', minChars: 'Minimo 8 caratteri',
    confirmPassword: 'Conferma password', repeatPassword: 'Ripeti la password',
    updating: 'Aggiornamento...', changePassword: 'Cambia password',
    errorTitle: 'Errore nel cambio', errorDesc: 'Problema nel cambio della password',
  },

  contactFormPage: {
    seoTitle: 'Modulo di Contatto | Punto Hispano',
    seoDesc: 'Contattaci per informazioni sui nostri servizi per la comunità ispanofona in Svizzera.',
    title: 'Modulo di Contatto',
    subtitle: 'Compila il modulo qui sotto per inviarci la tua richiesta. Il nostro team ti risponderà il prima possibile.',
    successTitle: 'Messaggio inviato!',
    successDesc: 'Grazie per averci contattato. Abbiamo ricevuto il tuo messaggio e ti risponderemo entro 24-48 ore lavorative.',
    sendAnother: 'Invia un altro messaggio',
    labelName: 'Nome completo',
    placeholderName: 'Inserisci il tuo nome',
    labelEmail: 'Indirizzo e-mail',
    placeholderEmail: 'nome@esempio.com',
    labelPhone: 'Telefono (opzionale)',
    placeholderPhone: 'Il tuo numero di telefono',
    labelServiceArea: 'Area di servizio',
    selectArea: "Seleziona un'area",
    optGestoria: 'Gestione e Amministrazione',
    optLegal: 'Consulenza Legale',
    optIdiomas: 'Corsi di Lingua',
    optSeguros: 'Assicurazioni e Pensioni',
    optDigital: 'Soluzioni Digitali',
    optCoches: 'Noleggio Auto',
    optViviendas: 'Affitto Abitazioni',
    labelMessage: 'Messaggio',
    placeholderMessage: 'Come possiamo aiutarti?',
    submitBtn: 'Invia Messaggio',
    sending: 'Invio in corso...',
    toastSuccess: 'Modulo inviato',
    toastSuccessDesc: 'Abbiamo ricevuto il tuo messaggio e ti contatteremo presto.',
    toastError: "Errore nell'invio",
    toastErrorDesc: "Si è verificato un problema nell'invio. Riprova.",
    privacyNote: 'Inviando questo modulo, accetti la nostra',
    privacyLink: 'informativa sulla privacy',
    privacyNote2: 'e il trattamento dei tuoi dati per rispondere alla tua richiesta.',
    fastResponse: 'Risposta rapida',
    fastResponseDesc: '24-48 ore lavorative',
    noCommitment: 'Senza impegno',
    noCommitmentDesc: 'Preventivi personalizzati',
    spanishSupport: 'Assistenza in spagnolo',
    spanishSupportDesc: 'Team 100% ispanofono',
    validationName: 'Il nome deve avere almeno 2 caratteri',
    validationEmail: 'Inserisci un indirizzo e-mail valido',
    validationService: "Seleziona un'area di servizio",
    validationMessage: 'Il messaggio deve avere almeno 10 caratteri',
    interestedIn: 'Sono interessato a informazioni sui servizi di',
  },

  serviceTemplates: {
    freeWhatsapp: 'Consulenza Gratuita via WhatsApp',
    askWhatsapp: 'Richiedi Informazioni via WhatsApp',
    whatsappDirect: 'WhatsApp Diretto',
    notSure: 'Non sei sicuro di cosa hai bisogno? Scrivici — ti orientiamo gratuitamente.',
    backTo: 'Torna a',
    popular: 'Popolare',
    bestSeller: 'Più Venduto',
    allIncluded: 'Tutto Incluso',
    free: 'Gratuito',
    servicesAvailable: 'servizi disponibili',
    serviceAvailable: 'servizio disponibile',
    packagesAvailable: 'pacchetti disponibili',
    packageAvailable: 'pacchetto disponibile',
    whichForYou: 'Qual è quello giusto per te?',
    freeConsultation: 'Consulenza Gratuita via WhatsApp',
    gestoriaBreadcrumb: 'Gestione Amministrativa',
    legalBreadcrumb: 'Consulenza Legale',
    legalFreeConsult: 'Consulenza Gratuita via WhatsApp',
    legalNotSure: 'Non sei sicuro di cosa hai bisogno? Ti orientiamo gratuitamente.',
    segurosBreadcrumb: 'Assicurazioni & Previdenza',
    segurosInsured: '+20.000 persone assicurate in 5 anni',
    relocationBreadcrumb: 'Pack Relocation',
    relocationNeedHelp: 'Ciao, ho bisogno di orientamento sul Pack Relocation.',
  },
  cookieBanner: {
    title: 'Cookie',
    description: 'Utilizziamo i cookie per migliorare la tua esperienza.',
    moreInfo: 'Maggiori info',
    adjust: 'Personalizza',
    reject: 'Rifiuta',
    accept: 'Accetta',
    preferences: 'Preferenze',
    necessary: 'Necessari',
    functional: 'Funzionali',
    analytics: 'Analitici',
    marketing: 'Marketing',
    required: 'obbligatorio',
    onlyNecessary: 'Solo necessari',
    save: 'Salva',
  },
  sectionNav: {
    home: 'Home',
    services: 'Servizi',
    about: 'Chi siamo',
    process: 'Processo',
    testimonials: 'Testimonianze',
    faq: 'FAQ',
    contact: 'Contatto',
  },
  helpWidget: {
    help: 'Aiuto?',
    assistant: 'Assistente',
    minimize: 'Minimizza widget di aiuto',
    howCanWeHelp: 'COME POSSIAMO AIUTARTI?',
    online: 'Siamo online',
    closeMenu: 'Chiudi menu di aiuto',
    aiChat: "CHAT CON L'IA",
    aiChatDesc: 'Risposta immediata 24/7',
  },
};

export default it;
